import { CGameBase, CGameState } from "./CGameBase";
import { CGame } from "./CGame";
import { SoundMgr } from "./SoundMgr";
import { CNetPeer } from "./CNetPeer";
import { CDefine, CEnumTypes, CMJClass, CMJHuType } from "./CEnumTypes";
import { CLoginPlayer } from "./CLoginPlayer";
import { CByteArray } from "./CByteArray";
import { CPointer } from "./CPointer";
import { CMJCard } from "./CMJCard";
import { CMJPlayer } from "./CMJPlayer";
import { sprintf } from 'sprintf-js';
import { CLobbyTable } from "./CLobbyTable";
import { CGameTable } from "./CGameTable";
import { CDiceSP } from "./CDiceSP";
import { CMultipleThiSel } from "./CMultipleThiSel";
import { CMultipleGunSel } from "./CMultipleGunSel";
import { CTPGHMenu } from "./CTPGHMenu";
import { CMJWindShow } from "./CMJWindShow";
import { CTPGHState } from "./CTPGHState";
import { CMJCore } from "./CMJCore";
import { CPonDataRec } from "./CPonDataRec";
import { CMySprite } from "./CMySprite";
import { CCountDown } from "./CCountDown";
import { CTipsSP } from "./CTipsSP";
import { CDragObject } from "./CDragObject";
import { CMyHand } from "./CMyHand";
import { CConfig } from "./CConfig";
import { CPacket } from "./CPacket";
import { CMJLobby } from "./CMJLobby";

export class CMJGame extends CGameState {
	public static TIME_MOVE_CARD:number = 160;
	public static COORD_STAND:number = 0;
	public static COORD_OPEN:number = 1;
	public static COORD_HUA:number = 2;
	public static COORD_TPGH:number = 3;
	public static COORD_PUTOUT:number = 4;
	public static COORD_GETUP:number = 5;
	public static COORD_GETDOWN:number = 6;
	public static COORD_GPOFS:number = 116;
	public static COORD_INFO:number = 5;
	public static OUTCARD_SHOW_TIME:number = 500;

	private m_mjCoords:Array<any> = new Array(328 * 5);
	private m_mjLnStep = [17, 17, 8, 20, 18, 18, 18]; 
	private m_mjLnOfs = [0, 17, 34, 42, 62, 80, 98];
	private m_HUText:string[] = ["莊家", "連", "拉", "台", 
				"門清", "自摸", "門清自摸", "槓上開花", "海底撈月", "搶槓", "全求", 
				"獨聽", "門風", "圈風", "花牌", "花槓", "八仙過海", "平胡", "碰碰胡", 
				"三暗刻", "四暗刻", "五暗刻", "混一色", "清一色", "小三元", "大三元", 
				"小四喜", "大四喜", "七搶一", "天胡", "地胡", "聽牌", "紅中", "青發", 
				"白板", "屁胡", "天聽", "地聽", "東風", "南風", "西風", "北風", "無字無花", 
				"槓牌", "暗槓", "河底撈魚", "字一色", "清老頭", "四槓", "斷么九", "雙龍抱", 
				"三色同順", "一條龍", "混全帶么", "純全帶么", "混老頭", "合計"];

    private mainView: fgui.GComponent;
	private mGame:CGame = null;
	private static m_instance:CMJGame = null;
	private m_GTable:CGameTable;
	private m_cgIndex:number;

	private m_mcResult:fgui.GComponent;
	private m_mcFinalResult:fgui.GComponent;
	private m_Dices:CDiceSP;
	public m_MultiThiSel:CMultipleThiSel;
	public m_MultiGunSel:CMultipleGunSel;
	public m_cTPGH:CTPGHMenu;
	public m_cSWind:CMJWindShow;
	public m_Core:CMJCore;
	public m_CRTips:CTipsSP;
	public m_MySprite:CMySprite;
	public m_cCntDown:CCountDown;
	public m_cHand:CMyHand;

	private m_objDrag:CDragObject = new CDragObject();
	private m_mcMOver:fgui.GMovieClip;

	public m_sPlayers:Array<CMJPlayer>;
	public m_cPointer:CPointer;
	public m_cCards:Array<CMJCard>;

	private m_SyncCardBuf:CByteArray = new CByteArray(CDefine.CARDS_PER_PLAYER);
	private m_WorkBuf:CByteArray = new CByteArray(256);
	public m_RemoteStep:CByteArray = new CByteArray(256);
	protected m_CardVs:CByteArray = new CByteArray(CDefine.TOTAL_MJ_CARDS);
	public m_Order:CByteArray = new CByteArray(CDefine.PLAYER_NUMS);
	public m_State:CByteArray = new CByteArray(4);
	public m_ocFlag:CByteArray = new CByteArray(4);	// 出牌後，各家胡碰槓吃牌檢查
	private m_ReplayStatus:CByteArray = new CByteArray(3);
	private m_Dice:CByteArray = new CByteArray(3);
	public m_PonData:CPonDataRec;

	private m_UseDrag:boolean = false;
	
	private m_ResTween:createjs.Tween;

	private m_DiceNum:number;
	public m_Turn:number;
	public m_OTurn:number;
	public m_CurCard:number;
	public m_LastCard:number;
	public m_StartDealer:number;
	public m_RoundWind:number;
	public m_Dealer:number;
	public m_DealerCnt:number;
	public m_OutCardCnt:number;
	public m_idxDealer:number;
	public m_CurOutIdx:number;
	public m_UserIdx:number;
	public m_CardRemain:number;
	public m_gTingFlag:number;
	public m_WinTurn:number = 0;
	public m_ClickValue:number;
	public m_fgTPGHWait:number;
	public m_EndFlag:number;
	public m_RemoteIdx:number;
	private m_fgEndGame:number;
	private m_idxPMJC:number;
	private m_cntDismiss:number;
	private m_firstCardReady:boolean;
	private m_fgResult:boolean;

	private m_tmBack2Lobby:number = 0;

	private m_fgTestOnly:boolean = false;

	public constructor() {
		super();
		this.mGame = CGame.Instance;
		this.m_Core = new CMJCore(this);
	}

	public static get Instance():CMJGame {
		if( this.m_instance == null ) this.m_instance = new CMJGame();
		return this.m_instance;
	}

	public get m_mcLayout():fgui.GComponent { return this.mainView; }
	public get mjCoords():Array<any> { return this.m_mjCoords; }
	public get GTable():CGameTable { return this.m_GTable; }

	public SendFlag(subType:number, buf:CByteArray, size:number):void {
		this.mGame.resetPacket();
		this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_GAME_SESSION);
		this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_GAME_MESSAGE);
		this.mGame.m_CPkt.WriteByte(subType);
		this.mGame.m_CPkt.WriteShort(size);
		this.mGame.m_CPkt.WriteInt(this.mGame.m_clTable.idxTable);
		if( size > 0 ) this.mGame.m_CPkt.WriteBytes(buf, 0, size);
		this.mGame.SendReliableData(this.mGame.m_CPkt);
	}
	// public SendCmd(subType:number, buf:CByteArray, size:number):void {
	// 	this.SendFlag(subType, buf, size);
	// }
	
	public AddDelayCall(dm:number, Callback:Function, v:number = 0):void {
		let mc = this.m_mjCoords[0] as fgui.GMovieClip;
		createjs.Tween.get(mc)
			.wait(dm)
			.call(function() {
				Callback(v);
			});
	}

	public HideOutCardBG(n:number = -1):void {
		if( n == -1 ) {
			for ( let i = 0; i < 4; i ++ ) {
				let idx = (i+4) * CMJGame.COORD_INFO;
				let mc = this.m_mjCoords[idx] as fgui.GMovieClip;
				mc.visible = false;
			}
		}
		else {
			let idx = (n+4) * CMJGame.COORD_INFO;
			let mc = this.m_mjCoords[idx] as fgui.GMovieClip;
			mc.visible = false;
		}
	}

	public ShowOutCardBG(n:number):void {
		let idx = (n+4) * CMJGame.COORD_INFO;
		let mc = this.m_mjCoords[idx] as fgui.GMovieClip;
		mc.visible = true;
	}

	public Cleanup():void {
		createjs.Tween.removeAllTweens();
		if( this.m_UseDrag ) {
			for (let i = 0; i < this.mainView.numChildren; i++) {
				let c = this.mainView.getChildAt(i);
				if (fgui.utils.StringUtil.startsWith(c.name, "pos_P00_00_")) {
					c.displayObject.removeAllListeners();
				}
			}
		}
		else {
			this.mGame.SetGObjectCallbackFunc(this.mainView, this.onClickMJCards, false, this);
		}
		this.mGame.SetGObjectCallbackFunc(this.mainView, this.onClickIntfButton, false, this);
		fgui.GRoot.inst.removeChild(this.mainView);
		this.m_cTPGH.release(this.ClickBtnTPGH);
		this.m_MultiThiSel.release(this.onClickMultiThiSel);
		this.m_MultiGunSel.release(this.onClickMultiGunSel);
		this.m_PonData.release();
		this.m_PonData = null;
		this.m_GTable = null;
		this.mainView.dispose();
		this.mainView = null;
		this.m_cPointer = null;
		this.m_Dices = null;
		this.m_cCards = null;
		this.m_cSWind = null;
		this.m_sPlayers = null;
		this.m_MySprite = null;
		this.m_cCntDown = null;
		this.m_CRTips = null;
		this.m_cHand = null;
		CGame.DebugLog("mjGameScene Cleanup done.");
	}

	// private onGTimerTrigger():void {
	// 	this.m_cPointer.Show(this.m_Cnt&3);
	// 	CGame.DebugLog("Timer trigger: ", this.m_Cnt++);
	// }

	public Init():void {
		CGame.DebugLog("mjGameScene Init.");

        let ins = fgui.UIPackage.createObject("mjGameScene", "mainGame") as fgui.GComponent;
        ins.setSize(fgui.GRoot.inst.width, fgui.GRoot.inst.height);
		ins.addRelation(fgui.GRoot.inst, fgui.RelationType.Size);
		//ins.x = fgui.GRoot.inst.width;
		fgui.GRoot.inst.addChild(ins);
		this.mainView = ins;

		CGame.DebugLog("Rules:", this.mGame.m_clTable.Base, this.mGame.m_clTable.Bonus, this.mGame.m_clTable.Secs);

		// let BG = this.mainView.getChild("img_BG") as fgui.GLoader;
		// // BG.url = "ui://mjBG/0201";
		// BG.url = "images/BG/0301.jpg";

		this.m_cntDismiss = 0;
		this.m_fgResult = false;
		this.m_firstCardReady = false;
		this.m_RoundWind = 0;
		this.m_idxDealer = 0;
		this.m_DealerCnt = 0;
		this.m_Dealer = 0;
		this.m_State.SetInt(0, 0);
		this.m_mcMOver = null;
		this.m_idxPMJC = -1;
		this.m_fgEndGame = 0;
		this.m_tmBack2Lobby = 0;

		this.m_GTable = new CGameTable();
		this.m_Dices = new CDiceSP();
		this.m_MultiThiSel = new CMultipleThiSel();
		this.m_MultiGunSel = new CMultipleGunSel();
		this.m_PonData = new CPonDataRec();
		this.m_sPlayers = new Array<CMJPlayer>(CDefine.PLAYER_NUMS);

		for ( let i = 0; i < CDefine.PLAYER_NUMS; i ++ ) {
			this.m_sPlayers[i] = new CMJPlayer();
		}
		this.m_cCards = new Array<CMJCard>(CDefine.TOTAL_MJ_CARDS);
		for ( let i = 0; i < CDefine.TOTAL_MJ_CARDS; i ++ ) {
			this.m_cCards[i] = new CMJCard(this);
		}
		this.m_MySprite = new CMySprite(this.mainView);
		this.m_cCntDown = new CCountDown(this.mainView, this.mGame.m_clTable.Secs);

		let t = this.mainView.getChild("txt_RoomNumber") as fgui.GTextField;
		t.text = "房號: " + this.mGame.m_clTable.idxTable;

		var idx:number;
		for (let i = 0; i < ins.numChildren; i++) {
            let obj = ins.getChildAt(i) as fgui.GObject;
			if( obj.name.slice(0, 3) == "pos" ) {
				obj.visible = false;
				if( obj.name.slice(4, 7) == "Out" ) {
					idx = parseInt(obj.name.slice(7, 8));
					idx *= CMJGame.COORD_INFO;
				}
				else if ( obj.name.slice(4, 11) == "DropOut" ) {
					idx = parseInt(obj.name.slice(11, 12));
					idx += 4;
					idx *= CMJGame.COORD_INFO;
				}
				else {
					let n = parseInt(obj.name.slice(6, 7));
					let ln = parseInt(obj.name.slice(9, 10));
					idx = parseInt(obj.name.slice(11));
					idx += (n * CMJGame.COORD_GPOFS);
					idx += this.m_mjLnOfs[ln];
					idx += 8;
					idx *= CMJGame.COORD_INFO;
					let mc = (obj as unknown) as fgui.GMovieClip;
					//CGame.DebugLog(mc.name, mc.resourceURL, mc.customData);
				}
				if( idx >= 0 ) {
					this.m_mjCoords[idx] = obj;
					this.m_mjCoords[idx + 1] = obj.x;
					this.m_mjCoords[idx + 2] = obj.y;
					this.m_mjCoords[idx + 3] = obj.width;
					this.m_mjCoords[idx + 4] = obj.height;
					//CGame.DebugLog(obj.name, ":", idx);
					if ( obj.name.slice(0, 10) == "pos_P00_00" ) {
						if ( obj.name == "pos_P00_00_0" ) this.m_idxPMJC = idx;
						// if( this.m_fgTestOnly ) obj.visible = true;
						obj.displayObject.interactive = true;
						if( this.m_UseDrag )
							obj.displayObject.addListener("mousedown", this.onMouseDownMJCards.bind(this));
					}
					// else if ( this.m_fgTestOnly && obj.name.slice(0, 10) == "pos_P01_00" ) {
					// 	obj.visible = true;
					// }
				}
			}
			else if ( obj.name.slice(0, 2) == "mc" ) {
				obj.visible = false;
				if ( obj.name == "mc_Pointer" ) {
					obj.visible = true;
					this.m_cPointer = new CPointer(obj as fgui.GComponent);
				}
				else if ( obj.name == "mc_TPGH" ) {
					this.m_cTPGH = new CTPGHMenu();
					this.m_cTPGH.init(obj as fgui.GComponent, this.ClickBtnTPGH.bind(this), this.onEndTPGHInFunc.bind(this));
				}
				else if ( obj.name == "mc_BewardTips" ) {
					this.m_CRTips = new CTipsSP(obj as fgui.GMovieClip);
				}
				else if ( obj.name == "mc_Result" ) {
					this.m_mcResult = obj as fgui.GComponent;
				}
				else if ( obj.name == "mc_FinalResult" ) {
					this.m_mcFinalResult = obj as fgui.GComponent;
				}
				else if ( obj.name == "mc_Hand" ) {
					this.m_cHand = new CMyHand(obj as fgui.GComponent);
				}
				else if ( obj.name == "mc_StartPlay" ) {
					//m_CRStartPlay = new CMySprite(MovieClip(obj), 1);
				}
				else if ( obj.name == "mc_Draw01" ) {
					//m_CRDraw1 = new CMySprite(MovieClip(obj), 3);
				}
				else if ( obj.name == "mc_Draw00" ) {
					//m_CRDraw2 = new CMySprite(MovieClip(obj), 3);
				}
				else if ( obj.name == "mc_CountDown" ) {
					//m_cCntDown.attachMCNum(MovieClip(obj));
				}
			}
			else if ( obj.name.slice(0, 3) == "com" ) {
				obj.visible = false;
			}
			// if( obj.numChildren != undefined && obj.numChildren > 1 ) {
			// 	CGame.DebugLog(obj.name, obj.numChildren);
			// }
        }

		// let wifi = this.mainView.getChild("mov_Wifi") as fgui.GMovieClip;
		// wifi.visible = CConfig.showWifiStatus;
		// this.mGame.m_updateWifi = CConfig.showWifiStatus;

		// this.m_cPointer = new CPointer(this.mainView);

		this.mGame.SetGObjectCallbackFunc(this.mainView, this.onClickIntfButton, true, this);
		if( this.m_UseDrag == false )
			this.mGame.SetGOCallbackFunc(this.mainView, "pos_P00_00_", 17, this.onClickMJCards, true, this);

		this.m_Dices.Init(this.mainView);
		this.m_cSWind = new CMJWindShow();
		this.m_cSWind.attachMCWind(this.mainView);
		//this.m_cSWind.Set(0, 1, this.endShowWind.bind(this), 1);

		let thi = this.mainView.getChild("mc_ThiSelBar") as fgui.GComponent;
		this.m_MultiThiSel.init(thi, this.onClickMultiThiSel.bind(this));
		// this.m_MultiThiSel.add(0x23, 0x24, 0x25, 0x0a, 0x0b, -1);
		// this.m_MultiThiSel.add(0x24, 0x25, 0x26, 0x0b, -1, 0x0c);
		// this.m_MultiThiSel.show();

		let gun = this.mainView.getChild("mc_GunSelBar") as fgui.GComponent;
		this.m_MultiGunSel.init(gun, this.onClickMultiGunSel.bind(this));
		// this.m_MultiGunSel.add(0x13, 0x02);
		// this.m_MultiGunSel.add(0x24, 0x0b);
		// this.m_MultiGunSel.show();
		this.m_PonData.init();

		// let btn = this.mainView.getChild("btn_Computer") as fgui.GButton;
		// btn.visible = false;

		// if( this.m_fgTestOnly ) {
		// 	for( let i = 0; i < CDefine.PLAYER_NUMS; i ++ ) {
		// 		this.m_Order[i] = i;
		// 		this.m_sPlayers[i].Init(i, this);
		// 		this.m_sPlayers[i].SetPlayerNum(i);
		// 		this.m_sPlayers[i].m_nWind = i;
		// 		for( let j = 0; j < CDefine.CARDS_PER_PLAYER; j ++ ) {
		// 			this.m_sPlayers[i].m_Cards[j] = i * CDefine.CARDS_PER_PLAYER+j+10;
		// 		}
		// 	}
		// 	let col = CDefine.TOTAL_MJ_CARDS / (2*4);
		// 	let st = this.GetPosDir(0, 1);
		// 	let j = 0;
		// 	for ( let i = 0; i < CDefine.TOTAL_MJ_CARDS; i ++ ) {
		// 		let ofs = this.GetCoordsInfo((i >> 1) % col, st, CMJGame.COORD_GETUP + (i & 1));
		// 		this.m_cCards[i].SetV(255, ofs);
		// 		j ++;
		// 		if( j >= (col*2) ) { 
		// 			j = 0; 
		// 			st --;
		// 			if( st < 0 ) st += 4; 
		// 		}
		// 	}
		// 	// this.m_CurCard = 100;
		// 	// this.m_LastCard = 10;
		// 	// this.Bu3Hua1(this.m_sPlayers[0], 15, 0x52, 0x40, 500);
		// 	// this.Bu3Hua1(this.m_sPlayers[1], 14, 0x50, 0x24, 1000);
		// 	// this.Bu3Hua1(this.m_sPlayers[1], 15, 0x54, 0x11, 1000);
		// 	this.m_sPlayers[0].ShowTing(true);
		// }

		//let buf:CByteArray = new CByteArray([0,3,1,2,3,4,2]);
		//this.PreDecideSeat(buf);

		// idx = this.GetCoordsInfo(15, 0, CMJGame.COORD_STAND);
		// let mc = this.m_mjCoords[idx] as fgui.GMovieClip;
		// mc.visible = true;

		// var i, n, ofs;
		// this.m_cCards = new Array<CMJCard>(10);
		// for( i = 0; i < 10; i ++ ) {
		// 	this.m_cCards[i] = new CMJCard(this);
		// }
		// ofs = this.GetCoordsInfo(16, 0, CMJGame.COORD_STAND);
		// this.m_cCards[6].SetV((CDefine.MJTYPE_TOONG << 4) | 6, ofs);
		
		// this.m_Cnt = 10;

		// fgui.GTimer.inst.add(5000, 12, this.onGTimerTrigger, this);
		if( this.m_fgTestOnly == false ) {
			this.mGame.resetPacket();
			this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_GAME_SESSION);
			this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_ENTER_GAME);
			this.mGame.m_CPkt.WriteInt(this.mGame.m_clTable.idxTable);
			this.mGame.m_CPkt.WriteInt(this.mGame.m_pUserPlayer.DBID);
			this.mGame.m_CPkt.WriteUTFBytes(this.mGame.m_pUserPlayer.openid, CLoginPlayer.OPENID_LEN);
			this.mGame.m_CPkt.WriteInt(this.mGame.m_ReLogin);
			this.mGame.SendReliableData(this.mGame.m_CPkt);

			if( this.mGame.m_ReLogin ) {
				this.mGame.ShowDialog("重新登入", "等待資料中(依狀態，等待時間不一)，請稍後… ", []);
			}

			// var url = sprintf("ws://%s:%d", this.mGame.m_clTable.serverIP, this.mGame.m_clTable.serverPort);
			// var that = this;
			// this.mGame.ConnectToServer(url, 1, function(res) {
			// 	that.mGame.ShowDialog("錯誤!!", res, ["確定"], function (result) {
			// 		CGame.DebugLog(result);
			// 		that.mGame.ChangeState(CMJLobby.Instance);
			// 	});
			// });
		}
	    //SoundMgr.playMusic("mus/m001.mp3");
		//createjs.Tween.get(ins).to({x:0}, 500, createjs.Ease.quadOut);
	}

	public updateWifiStatus():void {
		let wifi = this.mainView.getChild("mov_Wifi") as fgui.GMovieClip;
		if( this.mGame.m_connState < 2 ) wifi.frame = 0;
		else if( this.mGame.m_connState < 5 ) wifi.frame = 1;
		else if( this.mGame.m_connState < 10 ) wifi.frame = 2;
		else wifi.frame = 3;
	}

	private endShowWind(v:number):void {
		this.m_cTPGH.In(3, 1); 
	}

	private onEndTPGHInFunc():void {
		if( this.mGame.m_clTable.fgTingHu ) {
			var pMP:CMJPlayer = this.m_sPlayers[this.m_Order[this.m_UserIdx]];
			if( pMP.isTing() && this.m_cTPGH.isEnable(4) ) {
				this.m_ClickValue = 10000 + 4;
			}
		}
	}

	private RequestDismiss(result:boolean):void {
		if( result ) {
			this.m_cntDismiss ++;
			this.SendFlag(CMJClass.MJGAME_REQUEST_DISMISS, this.m_RemoteStep, 0);
			//this.mGame.ShowDialog("解散房間", "詢問其他玩家中… ", ["確定"], null);
		}
	}

	private onClickRoomRuleButton(e: PIXI.InteractionEvent): void {
		let btn = fgui.GObject.castFromNativeObject(e.currentTarget);
		CGame.DebugLog(btn.name);
		let curPannel = this.mainView.getChild("mc_RoomRule") as fgui.GComponent;
		if ( btn.name == "btn_Confirm") {
			this.mGame.SetGObjectCallbackFunc(curPannel, this.onClickRoomRuleButton, false, this);
			curPannel.visible = false;
		}
	}

	private ShowRoomRulePannel():void {
		let curPannel = this.mainView.getChild("mc_RoomRule") as fgui.GComponent;
		let base = this.mGame.m_clTable.Base;
		let bonus = this.mGame.m_clTable.Bonus;
		let time = this.mGame.m_clTable.Secs;
		let t = curPannel.getChild("txt_Title") as fgui.GTextField;
		t.text = "房間規則";
		// let c = curPannel.getController("cCard");
		// c.selectedIndex = this.mGame.m_clTable.Cost;
		// t = curPannel.getChild("txt_Cost") as fgui.GTextField;
		// if( c.selectedIndex == 0 ) t.text = "1";
		// else 					   t.text = "4";
		t = curPannel.getChild("txt_Base") as fgui.GTextField;
		t.text = base + '';
		t = curPannel.getChild("txt_Bonus") as fgui.GTextField;
		t.text = bonus + '';
		t = curPannel.getChild("txt_Time") as fgui.GTextField;
		t.text = time + '';
		t = curPannel.getChild("txt_Password") as fgui.GTextField;
		t.text = "";
		this.mGame.SetGObjectCallbackFunc(curPannel, this.onClickRoomRuleButton, true, this);
		let c = curPannel.getController("cTingGun");
		c.selectedIndex = this.mGame.m_clTable.fgTinGun;
		c = curPannel.getController("cTingHu");
		c.selectedIndex = this.mGame.m_clTable.fgTingHu;
		c = curPannel.getController("cRound");
		c.selectedIndex = this.mGame.m_clTable.Round >> 1;
		c = curPannel.getController("cPassword");
		c.selectedIndex = this.mGame.m_clTable.fgPass;
		for( let i = 0; i < curPannel.numChildren; i ++ ) {
			let b = curPannel.getChildAt(i);
			if (fgui.utils.StringUtil.startsWith(b.name, "btn_")) {
				if( b.name != "btn_Cancel" && b.name != "btn_Confirm" ) {
					b.enabled = false;
				}
			}
		}
		let b = curPannel.getChild("btn_Cancel") as fgui.GButton;
		b.visible = false;
		curPannel.visible = true;
	}

	private onClickIntfButton(e:PIXI.InteractionEvent):void {
		let btn = fgui.GObject.castFromNativeObject(e.currentTarget);
		CGame.DebugLog(btn.name);
		SoundMgr.play("s002");
		if( btn.name == "btn_Leave" ) {
			//this.BackToLobby();
			if( this.m_cntDismiss < 3 ) {
				var that = this;
				// this.mGame.ShowDialog("解散房間", "這樣會被處罰的！確定要發起解散嗎？", ["還是要", "那算了"], this.RequestDismiss.bind(this));
				this.mGame.ShowDialog("解散房間", "確定要發起解散嗎？", ["還是要", "那算了"], this.RequestDismiss.bind(this));
			}
			else {
				this.mGame.ShowDialog("", "沒人答應再問也沒用，還是把這一場打完吧！", ["確定"]);
				btn.visible = false;
			}
		}
		else if( btn.name == "btn_Rule" ) {
			this.ShowRoomRulePannel();
		}
		else if( btn.name == "btn_Option" ) {
			// this.mGame.DisconnectServer(0, true);
			this.mGame.ShowSetupDialog();
			// document.body.style.display = 'none';
			// this.mGame.closeWin();
		}
	}

	private ClickBtnTPGH(e:PIXI.InteractionEvent):void {
		let btn = fgui.GObject.castFromNativeObject(e.currentTarget);
		let n = parseInt(btn.name.slice(-1));
		CGame.DebugLog("=== ClickBtnTPGH:", btn.name, n);
		SoundMgr.play("s003");
		if( this.m_cTPGH.isEnable(n) ) {
			this.m_ClickValue = 10000 + n;
			//CSoundRes.Instance.PlayGameSound(5);
			if( n == 5 ) this.m_cTPGH.Out();
		}
	}

	private onClickMultiThiSel(e: PIXI.InteractionEvent): void {
		let btn = fgui.GObject.castFromNativeObject(e.currentTarget);
		let n = parseInt(btn.name.slice(-1));
		CGame.DebugLog("=== onClickMultiThiSel:", btn.name, n);
		SoundMgr.play("s003");
		this.m_MultiThiSel.setSel(n);
	}

	private onClickMultiGunSel(e: PIXI.InteractionEvent): void {
		let btn = fgui.GObject.castFromNativeObject(e.currentTarget);
		let n = parseInt(btn.name.slice(-1));
		CGame.DebugLog("=== onClickMultiGunSel:", btn.name, n);
		SoundMgr.play("s003");
		this.m_MultiGunSel.setSel(n);
	}

	private ResetDragObject():void {
		if ( this.m_objDrag.m_MouseDown ) {
			this.m_objDrag.m_MouseDown = false;
			this.m_objDrag.m_mc.displayObject.removeAllListeners("mousemove");
			this.m_objDrag.m_mc.displayObject.removeAllListeners("mouseup");
			this.m_objDrag.m_mc.x = this.m_objDrag.m_origx;
			this.m_objDrag.m_mc.y = this.m_objDrag.m_origy;
		}
	}
	private onMouseMoveMJCard(e:PIXI.InteractionEvent):void {
		//CGame.DebugLog("onMouseMoveMJCard ...");
		if ( this.m_objDrag.m_MouseDown ) {
			this.m_objDrag.m_mc.x = e.data.global.x - this.m_objDrag.m_ofsx;
			this.m_objDrag.m_mc.y = e.data.global.y - this.m_objDrag.m_ofsy;
		}
	}
	private onMouseUpMJCard(e:PIXI.InteractionEvent):void {
		if ( this.m_objDrag.m_MouseDown ) {
			CGame.DebugLog("onMouseUpMJCard:");
			this.m_objDrag.m_MouseDown = false;
			this.m_objDrag.m_mc.displayObject.removeAllListeners("mousemove");
			this.m_objDrag.m_mc.displayObject.removeAllListeners("mouseup");
			var my:number = this.m_objDrag.m_sy - e.data.global.y;
			if ( my > 20 ) {
				this.m_mcMOver = this.m_objDrag.m_mc;
				var v:number = parseInt(this.m_objDrag.m_mc.name.slice(11));
				this.m_ClickValue = v;
			}
			else {
				this.m_objDrag.m_mc.x = this.m_objDrag.m_origx;
				this.m_objDrag.m_mc.y = this.m_objDrag.m_origy;
				if ( Math.abs(my) < 3 ) {
					this.onDragMJCards(this.m_objDrag.m_mc);
				}
			}
		}
	}
	private onMouseDownMJCards(e: PIXI.InteractionEvent): void {
		let btn = fgui.GObject.castFromNativeObject(e.currentTarget);
		CGame.DebugLog(btn.name);
		if (!this.m_objDrag.m_MouseDown) {
			CGame.DebugLog("onMouseDownMJCard:", btn.name);
			if( btn.displayObject.interactive ) {
				SoundMgr.play("s002");
				this.m_objDrag.m_MouseDown = true;
				this.m_objDrag.m_mc = btn as fgui.GMovieClip;
				this.m_objDrag.m_mc.displayObject.addListener("mouseup", this.onMouseUpMJCard.bind(this));
				this.m_objDrag.m_mc.displayObject.addListener("mousemove", this.onMouseMoveMJCard.bind(this));
				this.m_objDrag.m_origx = this.m_objDrag.m_mc.x;
				this.m_objDrag.m_origy = this.m_objDrag.m_mc.y;
				this.m_objDrag.m_sx = e.data.global.x;
				this.m_objDrag.m_sy = e.data.global.y;
				this.m_objDrag.m_ofsx = e.data.global.x - this.m_objDrag.m_origx;
				this.m_objDrag.m_ofsy = e.data.global.y - this.m_objDrag.m_origy;
			}
		}
	}

	public SelMJCard(mc:fgui.GMovieClip):void {
		let idx = parseInt(mc.name.slice(11));
		idx *= CMJGame.COORD_INFO;
		idx += this.m_idxPMJC;
		createjs.Tween.get(mc)
				.to({ x:this.m_mjCoords[idx + 1], y:this.m_mjCoords[idx + 2] - 20.0, 
					width:this.m_mjCoords[this.m_idxPMJC + 3], 
					height:this.m_mjCoords[this.m_idxPMJC + 4]}, 100, createjs.Ease.linear);
	}
	public UnSelMJCard(mc:fgui.GMovieClip):void {
		let idx = parseInt(mc.name.slice(11));
		idx *= CMJGame.COORD_INFO;
		idx += this.m_idxPMJC;
		createjs.Tween.get(mc)
				.to({ x:this.m_mjCoords[idx + 1], y:this.m_mjCoords[idx + 2], 
					width:this.m_mjCoords[this.m_idxPMJC + 3], 
					height:this.m_mjCoords[this.m_idxPMJC + 4]}, 100, createjs.Ease.linear);
	}

	private onDragMJCards(mc:fgui.GMovieClip): void {
		CGame.DebugLog("onDragMJCards:", mc.name);
		var v:number = parseInt(mc.name.slice(11));	// pos_P00_00_16
		if ( mc == this.m_mcMOver ) {
			CGame.DebugLog(mc.name + ":" + v);
			this.m_ClickValue = v;
			this.m_mcMOver = null;
			//CSoundRes.Instance.PlayGameSound(3);
		}
		else {
			if ( this.m_mcMOver != null ) this.UnSelMJCard(this.m_mcMOver);
			this.m_mcMOver = null;
			this.m_mcMOver = mc;
			this.SelMJCard(this.m_mcMOver);
			//CSoundRes.Instance.PlayGameSound(2);
		}
		SoundMgr.play("s002");
	}

	private onClickMJCards(e: PIXI.InteractionEvent): void {
		let mc = fgui.GObject.castFromNativeObject(e.currentTarget) as fgui.GMovieClip;
		// CGame.DebugLog("onClickMJCards:", mc.name);
		var v:number = parseInt(mc.name.slice(11));	// pos_P00_00_16
		if ( mc == this.m_mcMOver ) {
			CGame.DebugLog("onClickMJCards:", mc.name, v);
			this.m_ClickValue = v;
			this.m_mcMOver = null;
			//CSoundRes.Instance.PlayGameSound(3);
		}
		else {
			if ( this.m_mcMOver != null ) this.UnSelMJCard(this.m_mcMOver);
			this.m_mcMOver = null;
			this.m_mcMOver = mc;
			this.SelMJCard(this.m_mcMOver);
			//CSoundRes.Instance.PlayGameSound(2);
		}
		SoundMgr.play("s002");
	}

	private ShowAndDisappearMC(mcName:string, dm:number):void {
		let mc = this.mainView.getChild(mcName) as fgui.GImage;
		mc.visible = true;
		createjs.Tween.get(mc)
					.wait(dm)
					.call(function(){
						mc.visible = false;
					})
	}

	private ShowPreDSCard():void {
		for ( let i = 0; i < 4; i ++ ) {
			this.m_cCards[i].GetMC().visible = true;
		}
		// let ofs = 0, n = 0;
		// for ( let i = 0; i < 4; i ++ ) {
		// 	n = this.m_WorkBuf[ofs++];
		// 	this.m_cCards[i].SetVS((CDefine.MJTYPE_WORDS << 4) | n, "mc_Decide" + i);
		// }
		// let dm = 0;
		// n = (this.m_DiceNum-1) & 3;
		// for( let i = 3; i >= 0; i -- ) {
		// 	let j = this.GetPosDir(n);
		// 	this.m_cCards[i].AddMove(j * CMJGame.COORD_INFO, 200, dm + 500 * (3 - i), 3);
		// 	if ( i == 0 ) {
		// 		this.m_cCards[i].AddDisappear(j * CMJGame.COORD_INFO, dm + 3000, this.DoDecideSeat.bind(this));
		// 	}
		// 	else {
		// 		this.m_cCards[i].AddDisappear(j * CMJGame.COORD_INFO, dm + 3000);
		// 	}
		// 	n ++; 
		// 	n &= 3;
		// }
	}

	private EndShowTransition(v:number):void {
		if( v == 1 ) {
			let ofs = 0, n = 0;
			let dicev:CByteArray = new CByteArray(3);
			for ( let i = 0; i < 4; i ++ ) {
				n = this.m_WorkBuf[ofs++];
				this.m_cCards[i].SetVS((CDefine.MJTYPE_WORDS << 4) | n, "mc_Decide" + i);
				this.m_cCards[i].GetMC().visible = false;
			}
			this.m_DiceNum = 0;
			for( let i = 0; i < 3; i ++ ) {
				n = this.m_WorkBuf[ofs++];
				dicev[i] = n;
				this.m_DiceNum += n;
			}
			CGame.DebugLog("dice:", dicev[0], dicev[1], dicev[2], this.m_DiceNum);
			SoundMgr.play("s004");
			this.m_Dices.Start(dicev, 1200, this.ShowPreDSCard.bind(this));
			let dm = 3500;
			n = (this.m_DiceNum-1) & 3;
			for( let i = 3; i >= 0; i -- ) {
				let j = this.GetPosDir(n);
				this.m_cCards[i].AddMove(j * CMJGame.COORD_INFO, 200, dm + 500 * (3 - i), 8);
				if ( i == 0 ) {
					this.m_cCards[i].AddDisappear(j * CMJGame.COORD_INFO, dm + 3000, this.DoDecideSeat.bind(this));
				}
				else {
					this.m_cCards[i].AddDisappear(j * CMJGame.COORD_INFO, dm + 3000);
				}
				n ++; 
				n &= 3;
			}
			for ( let i = 0; i < 4; i ++ ) {
				this.m_Order[i] = this.m_WorkBuf[ofs++];
			}
		}
	}

	public GetPosDir(order:number, clockwise:number = 0):number {
		var idx:number, ret:number;
		if( clockwise == 0 ) idx = this.m_Order[order];
		else				 idx = order;
		ret = this.m_sPlayers[idx].m_nPlayerNum;
		return ret;
	}
	// =======================================================================================
	// 使用牌─站0, 倒1, 花牌2, 吃碰牌3, 捨棄4
	// =======================================================================================
	public GetCoordsInfo(index:number, iGP:number, ln:number):number {
		var idx:number = index;
		idx += (iGP * CMJGame.COORD_GPOFS);
		idx += this.m_mjLnOfs[ln];
		idx += 8;
		idx *= CMJGame.COORD_INFO;
		//CGame.DebugLog("index:", index, iGP, ln, idx);
		return idx;
	}
	protected GetCardIn(lpMP:CMJPlayer, cv:number, idx:number, bfLast:boolean, lDelay:number, callback:Function = null, v:number = 1):number {
		var cnt:number, index:number, rn:number = 0, fgOpen:number = 1;
		
		if( !bfLast ) {
			index = this.m_CurCard ++;
			if( this.m_CurCard >= CDefine.TOTAL_MJ_CARDS ) this.m_CurCard = 0;
		}
		else {
			index = this.m_LastCard;
			if( this.m_LastCard & 1 ) {
				this.m_LastCard -= 3;
				if( this.m_LastCard < 0 ) this.m_LastCard += CDefine.TOTAL_MJ_CARDS;
			}
			else {
				this.m_LastCard ++;
				if( this.m_LastCard >= CDefine.TOTAL_MJ_CARDS ) this.m_LastCard = 0;
			}
		}
		this.m_OutCardCnt ++;
		this.m_cCards[index].SetV(cv);
		lpMP.m_Cards[idx] = index;
		lpMP.m_fgCardIn = 1;
		var ofs:number = this.GetCoordsInfo(idx, lpMP.m_nPlayerNum, CMJGame.COORD_STAND);
		if( lpMP.isTing() ) {
			if ( lpMP.m_nPlayerNum == 0 ) {
				this.m_cHand.Show(this.m_cCards[index].GetV(), 1500, CMJGame.TIME_MOVE_CARD-50, callback, v);
				this.m_cCards[index].ChgLocation(ofs, CMJGame.TIME_MOVE_CARD, lDelay, fgOpen, 8);//, callback, v);
				//this.m_cCards[index].ChgLocation(ofs, CMJGame.TIME_MOVE_CARD, lDelay+800, fgOpen, 8, callback, v);
			}
			else {
				fgOpen = 0;
				rn = this.m_cCards[index].ChgLocation(ofs, CMJGame.TIME_MOVE_CARD, lDelay+800, fgOpen, 8, callback, v);
			}
		}
		else {
			if( lpMP.m_nPlayerNum != 0 ) fgOpen = 0;
			rn = this.m_cCards[index].ChgLocation(ofs, CMJGame.TIME_MOVE_CARD, lDelay, fgOpen, 8, callback, v);
		}
		cnt = this.m_LastCard - this.m_CurCard;
		if( cnt < 0 ) cnt += CDefine.TOTAL_MJ_CARDS;
		if( !(this.m_LastCard & 1) ) cnt += 2;
		if ( cnt <= 16 ) {			// 流局
			this.m_EndFlag |= CDefine.GEND_LIU2JU2;
			CGame.DebugLog("===================== GEND_LIU2JU2:");
		}
		this.m_CardRemain = cnt - 16;
		var i:number;
		index = this.m_LastCard;
		for ( i = 0; i < 16; i ++ ) {
			this.m_cCards[index].SetLast();
			if( index & 1 ) {
				index -= 3;
				if( index < 0 ) index += CDefine.TOTAL_MJ_CARDS;
			}
			else {
				index ++;
				if( index >= CDefine.TOTAL_MJ_CARDS ) index = 0;
			}
		}
		return rn;
	}
	// private PreDecideSeat(buf:CByteArray):void {
	// 	this.m_WorkBuf.Copy(0, buf, 0, buf.length);
	private PreDecideSeat():void {
		this.mGame.PlayTransition(this.mainView, "DecideSeat", this.EndShowTransition.bind(this), 1);
	}

	private DoDecideSeat():void {
		CGame.DebugLog("DoDecideSeat:", this.m_cCards[0].GetMC().name);
		var i:number, j:number;
		
		this.m_ReplayStatus.Reset();
		for ( i = 0; i < 4; i ++ ) {
			if ( this.mGame.m_pUserPlayer.DBID == this.m_GTable.player[this.m_Order[i]].DBID ) {
				this.m_UserIdx = i;
				break;
			}
		}
		j = this.m_UserIdx;
		for( i = 0; i < 4; i ++ ) {
			this.m_sPlayers[this.m_Order[j]].SetPlayerNum(i);
			j ++; j &= 3;
		}
		this.m_idxDealer = 0;
		this.m_StartDealer = this.m_Order[this.m_idxDealer];	// 起莊
		this.m_Dealer = this.m_StartDealer;		// 莊家
		for( i = 0; i < 4; i ++ ) {
			this.m_sPlayers[this.m_Order[i]].UpdateInfo(true, this.m_Order[i]);
		}
		this.AddDelayCall(1000, this.SendShuffleS.bind(this));
	}

	private SendShuffleS():void {
		this.SendFlag(CMJClass.MJGAME_SHUFFLE, this.m_RemoteStep, 0);
		CGame.DebugLog("SendShuffleS");
	}

	private Shuffle(v:number):void {
		var	i:number, j:number, rnd:number, col:number, st:number, ofs:number;
		var tmp:number;
		
		this.m_ResTween = null;
		this.m_ClickValue = -1;
		//m_mcMOver = null;
		this.m_CardRemain = 0;
		this.m_gTingFlag = 0;
		this.m_OTurn = -1;
		this.m_EndFlag = 0;
		this.m_RemoteIdx = 0;
		this.m_RemoteStep.Reset(0);
		for( i = 0; i < CDefine.PLAYER_NUMS; i ++ ) {
			this.m_sPlayers[i].Reset();
		}
		this.m_ocFlag.Reset();
		this.m_CurOutIdx = 254;
		this.m_OutCardCnt = 0;
		this.m_fgTPGHWait = 0;

		col = CDefine.TOTAL_MJ_CARDS / (2*4);
		st = this.GetPosDir(this.m_StartDealer, 1);
		j = 0;
		for ( i = 0; i < CDefine.TOTAL_MJ_CARDS; i ++ ) {
			ofs = this.GetCoordsInfo((i >> 1) % col, st, CMJGame.COORD_GETUP + (i & 1));
			this.m_cCards[i].SetV(255, ofs);
			j ++;
			if( j >= (col*2) ) { 
				j = 0; 
				st --;
				if( st < 0 ) st += 4; 
			}
		}
		
		this.m_State.SetInt(0, CMJClass.MJSTATE_DICE);
		st = this.GetPosDir(this.m_Dealer, 1);
		this.m_DiceNum = 0;
		//CSoundRes.Instance.PlayGameSound(1);
		SoundMgr.play("s004");
		this.m_Dices.Start(this.m_Dice, 1200, this.Deal.bind(this));
		for( i = 0; i < 3; i ++ ) {
			rnd = this.m_Dice[i];
			//m_pGame.Log(rnd);
			this.m_DiceNum += rnd;
		}
	}

	protected Deal(v:number):void {
		var i:number, j:number, k:number, ofs:number = 3+2;
		var iNum:number, iMod:number, icnt:number, dm:number, cv:number;

		this.m_State.SetInt(0, CMJClass.MJSTATE_DEAL_E);

		i = this.m_WorkBuf[ofs++];
		for( j = 0; j < 4; j ++ ) {
			this.m_sPlayers[this.m_Order[i]].m_nWind = this.m_WorkBuf[ofs++];
			this.m_sPlayers[this.m_Order[i]].UpdateInfo(false, this.m_Order[i]);
			i ++; i &= 3;
		}
		this.m_CurCard = this.m_WorkBuf.GetShort(ofs); ofs += 2;
		this.m_LastCard = this.m_WorkBuf.GetShort(ofs); ofs += 2;
		this.m_idxDealer = this.m_WorkBuf.GetShort(ofs); ofs += 2;
		
		this.m_Turn = this.m_idxDealer;
		iNum = CDefine.CARDS_PER_PLAYER / 4;
		iMod = CDefine.CARDS_PER_PLAYER % 4;
		dm = 0;
		for( i = 0, icnt = 0; i < iNum; i ++, icnt += 4 ) {
			for( j = 0; j < CDefine.PLAYER_NUMS; j ++ ) {
				for ( k = 0; k < 4; k ++ ) {
					cv = 255;
					if ( this.m_sPlayers[this.m_Order[this.m_Turn]].m_nPlayerNum == 0 ) cv = this.m_WorkBuf[ofs++];
					if( j == (CDefine.PLAYER_NUMS-1) && (icnt+k) == (CDefine.CARDS_PER_PLAYER-1) )
						this.GetCardIn(this.m_sPlayers[this.m_Order[this.m_Turn]], cv, icnt+k, false, dm, this.SendCheckFlowerS.bind(this));
					else
						this.GetCardIn(this.m_sPlayers[this.m_Order[this.m_Turn]], cv, icnt+k, false, dm);
				}
				this.m_Turn ++;
				if( this.m_Turn >= CDefine.PLAYER_NUMS ) this.m_Turn = 0;
				dm += (CMJGame.TIME_MOVE_CARD-20);
			}
		}
		if( iMod ) {	// 13張麻將
			for( j = 0; j < CDefine.PLAYER_NUMS; j ++ ) {
				for( k = 0; k < iMod; k ++ ) {
					cv = 255;
					if ( this.m_sPlayers[this.m_Order[this.m_Turn]].m_nPlayerNum == 0 ) cv = this.m_WorkBuf[ofs++];
					if( j == (CDefine.PLAYER_NUMS-1) && (icnt+k) == (CDefine.CARDS_PER_PLAYER-1) )
						this.GetCardIn(this.m_sPlayers[this.m_Order[this.m_Turn]], cv, icnt+k, false, dm, this.SendCheckFlowerS.bind(this));
					else
						this.GetCardIn(this.m_sPlayers[this.m_Order[this.m_Turn]], cv, icnt+k, false, dm);
				}
				this.m_Turn ++;
				if( this.m_Turn >= CDefine.PLAYER_NUMS ) this.m_Turn = 0;
				dm += (CMJGame.TIME_MOVE_CARD-20);
			}
		}
		this.m_Turn = this.m_idxDealer;
		for ( j = 0; j < CDefine.PLAYER_NUMS; j ++ ) {
			this.m_sPlayers[j].m_fgCardIn = 0;
			//if( this.m_sPlayers[j].m_nPlayerNum == 0 ) this.m_sPlayers[j].EnableCards(false);
		}
	}

	private SendCheckFlowerS(v:number):void {
		CGame.DebugLog("endDeal SendCheckFlowerS:" + v);
		for( var i = 0; i < CDefine.PLAYER_NUMS; i ++ ) {
			this.m_sPlayers[i].SortCards();
			if( this.m_sPlayers[i].m_nPlayerNum == 0 ) this.m_sPlayers[i].EnableCards(false);
			//CGame.DebugLog("SortCards:" + i);
		}
		// SoundMgr.play("s009");
		// this.m_MySprite.Show("mc_Flower", 2500, 0, this.DoCheckFlowerE.bind(this));
		// CGame.DebugLog("m_CRFlower.Show ..");
		//CSoundRes.Instance.PlayGameSound(6);
		this.SendFlag(CMJClass.MJGAME_CHECKFLOWER, this.m_RemoteStep, 0);
		CGame.DebugLog("SendCheckFlowerS");
	}

	private DoCheckFlowerE(v:number):void {
		CGame.DebugLog("DoCheckFlowerE:" + v);
		this.SendFlag(CMJClass.MJGAME_FIRSTCARDIN, this.m_RemoteStep, 0);
		this.m_State.SetInt(0, CMJClass.MJSTATE_FIRSTCARDALLREADY);
		//this.m_firstCardReady = true;
	}

	private Bu3Hua1(pMP:CMJPlayer, idx:number, ov:number, nv:number, dm:number, callback:Function=null):void {
		var i:number, icount:number, fg:number = 0;
		var ofs:number, index:number;
		
		if( callback != null ) pMP.m_tpState.Show(0);
		index = pMP.m_Cards[idx];
		CGame.DebugLog("Bu3Hua1:", idx, index, ov, nv);
		this.m_cCards[index].SetV(ov);
		ofs = this.GetCoordsInfo(pMP.m_nHuaCnt, pMP.m_nPlayerNum, CMJGame.COORD_HUA);
		this.m_cCards[index].ChgLocationImm(ofs, CMJGame.TIME_MOVE_CARD, dm, 1, 3);
		if( pMP.m_nHuaCnt < 8 ) pMP.m_Hua1Pai2[pMP.m_nHuaCnt++] = ov;
		this.GetCardIn(pMP, nv, idx, true, dm, callback);
	}

	private PlayerCardIn(v:number):void {
		CGame.DebugLog("PlayerCardIn:" + v);
		this.SendFlag(CMJClass.MJGAME_CARDINREADY, this.m_RemoteStep, 0);
	}
	
	private ResetToShuffleReady():void {
		var i:number;
		for ( i = 0; i < CDefine.TOTAL_MJ_CARDS; i ++ ) 
		this.m_cCards[i].Reset();
		for ( i = 0; i < 4; i ++ ) {
			this.m_sPlayers[i].ShowTing(false);
			this.m_sPlayers[i].UpdateInfo(false);
		}
		//CSoundRes.Instance.PlayMusFile(m_MusName);
		this.AddDelayCall(500, this.SendShuffleS.bind(this));
	}

	// ============================= 打出的牌移至海底廢牌 ==================================
	public FinishPutCard():number {
		var rn:number = 0;
		CGame.DebugLog("FinishPutCard:", this.m_CurOutIdx);
		
		if( this.m_CurOutIdx < CDefine.TOTAL_MJ_CARDS ) {
			var pOMP:CMJPlayer = this.m_sPlayers[this.m_Order[this.m_OTurn]];
			var ofs:number;

			this.HideOutCardBG(pOMP.m_nPlayerNum);
			ofs = this.GetCoordsInfo(pOMP.m_nOutCnt, pOMP.m_nPlayerNum, CMJGame.COORD_PUTOUT);
			if ( this.m_EndFlag & CDefine.GEND_LIU2JU2 ) { 
				this.m_State.SetInt(0, CMJClass.MJSTATE_LIU2JU2_S);
				this.m_cCards[this.m_CurOutIdx].ChgLocation(ofs, 100, 0, 0, 5);
				rn = 1;
			}
			else {
				this.m_cCards[this.m_CurOutIdx].ChgLocation(ofs, 100, 0, 0, 5);
			}
			pOMP.m_nOutCnt ++;
			if( pOMP.m_nOutCnt >= 18 ) pOMP.m_nOutCnt = 0;	// only for test
			this.m_CurOutIdx = 254;
			pOMP.SortCards();
			//PlayGameSound(18, FALSE);
		}
		return rn;
	}

	private ShowSkipHu(show:boolean):void {
		let obj = this.mainView.getChild("mc_SkipHU0") as fgui.GObject;
		obj.visible = show;
	}

	public PutCardOut(pMP:CMJPlayer, buf:CByteArray):void {//idx:int, cv:uint = 255, fgTing:int):int {
		var idx:number = buf[1];
		var cv:number = buf[2];
		var fgTing:number = buf[3];
		var skipHu:number = buf[4];
		
		if ( this.m_CurOutIdx == pMP.m_Cards[idx] ) return;
		var pMC:CMJCard = this.m_cCards[pMP.m_Cards[idx]];

		if ( pMP.m_nPlayerNum != 0 ) pMC.SetV(cv);
		CGame.DebugLog("PutCardOut:", idx, pMC.GetV().toString(16));
					
		if ( pMP.m_nPlayerNum == 0 ) {
			//this.ResetDragObject();
		}
		
		pMP.m_nOutC = idx;
		this.m_CurOutIdx = pMP.m_Cards[idx];
		pMP.m_fgGun = 0;
		pMC.SetStatus(1);
		pMP.m_huoSkip = skipHu;
		if( pMP.m_huoSkip == 0 ) {
			if ( this.m_Turn == this.m_UserIdx ) {
				this.ShowSkipHu(false);
			}
		}
		else if ( this.m_Turn == this.m_UserIdx ) {
			this.ShowSkipHu(true);
		}
		
		// if ( fgTing ) {
		// 	if( pMP.isTing() == false ) {
		// 		SoundMgr.playVoc("act03");
		// 		pMP.ShowTing(true);
		// 	}
		// 	if( this.m_gTingFlag == 0 ) {	// 有人聽牌，改播聽牌音樂
		// 		this.m_gTingFlag = 1;
		// 		//CSoundRes.Instance.PlayMusFile("m005");
		// 	}
		// }

		pMP.m_fgCardIn = 0;
		pMP.m_LastPonV = 255;
		
		let vname = sprintf("voc0%d%d", pMC.GetType(), pMC.GetValue());
		SoundMgr.playVoc(vname);
		pMC.AddMove(pMP.m_nPlayerNum * CMJGame.COORD_INFO, 100, 0, 11, this.ShowOutCardBG.bind(this), pMP.m_nPlayerNum);

		pMP.m_bCardIn.SetInt(0, 0);
		pMP.SetTPGH(0);
		
		if ( pMP.m_nPlayerNum == 0 ) {
			//m_mcMOver = null;
			if ( this.m_cTPGH.GetState() ) this.m_cTPGH.Out();
			pMP.EnableCards(false);
		}

		if ( fgTing ) {
			if( pMP.isTing() == false ) {
				SoundMgr.playVoc("act03");
				pMP.ShowTing(true);
			}
			if( this.m_gTingFlag == 0 ) {	// 有人聽牌，改播聽牌音樂
				this.m_gTingFlag = 1;
				//CSoundRes.Instance.PlayMusFile("m005");
			}
		}
		
		pMP.m_LimitCardOut[0] = 0;
		pMP.m_LimitCardOut[1] = 0;
		this.m_OTurn = this.m_Turn;
	}

	private SendCardOutReady(v:number):void {
		var ofs:number, i:number, n:number;
		var pMP:CMJPlayer = this.m_sPlayers[this.m_Order[this.m_OTurn]];
		var pMC:CMJCard;
		pMP.m_Cards[pMP.m_nOutC] = pMP.m_Cards[CDefine.CARDS_PER_PLAYER];
		pMP.m_Cards[CDefine.CARDS_PER_PLAYER] = 255;
		if ( pMP.m_Cards[pMP.m_nOutC] != 255 ) {
			ofs = this.GetCoordsInfo(pMP.m_nOutC, pMP.m_nPlayerNum, CMJGame.COORD_STAND);
			pMC = this.m_cCards[pMP.m_Cards[pMP.m_nOutC]];
			pMC.SetLocation(ofs);
		}
		if ( pMP.m_nPlayerNum == 0 ) {
			for ( i = pMP.m_iPCnt * 3; i < CDefine.CARDS_PER_PLAYER; i ++ ) {
				//CGame.DebugLog("SendCardOutReady:", i, pMP.m_Cards[i]);
				pMC = this.m_cCards[pMP.m_Cards[i]];
				n = this.GetCoordsInfo(i, pMP.m_nPlayerNum, CMJGame.COORD_STAND);
				pMC.SetLocation(n);
			}
		}
		pMP.SortCards();
		n = 0;
		// if ( pMP.m_nPlayerNum == 0 ) {
		// 	for ( i = 0; i < CDefine.CARDS_PER_PLAYER; i ++ ) {
		// 		pMC = this.m_cCards[pMP.m_Cards[i]];
		// 		this.m_RemoteStep[i] = pMC.GetV();
		// 	}
		// 	n = CDefine.CARDS_PER_PLAYER;
		// }
		this.SendFlag(CMJClass.MJGAME_CARDOUTREADY, this.m_RemoteStep, n);
		CGame.DebugLog("SendCardOutReady Done. ");
		// this.SyncCardsCheck();
	}

	private BuildActionMenu(buf:CByteArray):void {
		var n:number, i:number, tpgh:number, ofs:number = 0;
		var pMP:CMJPlayer;
		
		n = buf[0];
		tpgh = buf.GetWord(1);
		pMP = this.m_sPlayers[this.m_Order[n]];
		pMP.SetTPGH(tpgh);
		CGame.DebugLog("BuildActionMenu:", n, tpgh.toString(16));
		this.m_cTPGH.In(pMP.GetTPGH(), 1);
		this.m_cCntDown.Show();
		pMP.m_Flag[1] = 0;
		pMP.m_bCardIn.SetInt(0, 0);
		ofs = 3;
		if ( tpgh & CDefine.MJACTION_THI ) {
			this.m_MultiThiSel.reset();
			n = buf.GetByte(ofs);
			ofs ++;
			for ( i = 0; i < n; i ++ ) {
				this.m_MultiThiSel.add(buf.GetChar(4 + i * 6), buf.GetChar(5 + i * 6), buf.GetChar(6 + i * 6), 
								buf.GetChar(7 + i * 6), buf.GetChar(8 + i * 6), buf.GetChar(9 + i * 6));
				CGame.DebugLog("---> ", buf.GetChar(4 + i * 6).toString(16), buf.GetChar(5 + i * 6).toString(16)
				, buf.GetChar(6 + i * 6).toString(16), buf.GetChar(7 + i * 6), buf.GetChar(8 + i * 6), buf.GetChar(9 + i * 6));
			}
			ofs += (n * 6);
		}
		if ( tpgh & CDefine.MJACTION_PON ) {
			this.m_PonData.reset();
			n = buf.GetByte(ofs);
			ofs ++;
			for ( i = 0; i < n; i ++ ) {
				this.m_PonData.add(buf.GetChar(ofs + i * 2), buf.GetChar(ofs + 1 + i * 2));
				CGame.DebugLog("---> ", buf.GetChar(ofs + i * 2).toString(16), buf.GetChar(ofs + 1 + i * 2));
			}
			ofs += (n * 2);
		}
		if ( tpgh & CDefine.MJACTION_GUN ) {
			this.m_MultiGunSel.reset();
			n = buf.GetByte(ofs);
			ofs ++;
			for ( i = 0; i < n; i ++ ) {
				this.m_MultiGunSel.add(buf.GetChar(ofs + i * 2), buf.GetChar(ofs + 1 + i * 2));
				CGame.DebugLog("---> ", buf.GetChar(ofs + i * 2).toString(16), buf.GetChar(ofs + 1 + i * 2));
			}
		}
		this.m_State.SetInt(0, CMJClass.MJSTATE_TPGH);
		CGame.DebugLog("BuildActionMenu done.");
	}

	private SendActionSelMsg(row:number, idx:number = 0):void {
		var ofs:number = 0, i:number;
		CGame.DebugLog("SendActionSelMsg:", row);
		this.m_RemoteStep[ofs++] = row;
		if ( row == 0 ) {
			for ( i = 0; i < 3; i ++ ) {
				this.m_RemoteStep[ofs++] = this.m_MultiThiSel.getIndex(idx * 3 + i);
				this.m_RemoteStep[ofs++] = this.m_MultiThiSel.getValue(idx * 3 + i);
			}
			CGame.DebugLog("---> ", this.m_RemoteStep[1], this.m_RemoteStep[2], this.m_RemoteStep[3], 
			this.m_RemoteStep[4].toString(16), this.m_RemoteStep[5].toString(16), this.m_RemoteStep[6].toString(16));
		}
		else if ( row == 1 ) {
			this.m_RemoteStep[ofs++] = this.m_PonData.getIndex(idx);
			this.m_RemoteStep[ofs++] = this.m_PonData.getValue(idx);
			CGame.DebugLog("---> ", this.m_RemoteStep[1], this.m_RemoteStep[2].toString(16));
		}
		else if ( row == 2 ) {
			this.m_RemoteStep[ofs++] = this.m_MultiGunSel.getIndex(idx);
			this.m_RemoteStep[ofs++] = this.m_MultiGunSel.getValue(idx);
			CGame.DebugLog("---> ", this.m_RemoteStep[1], this.m_RemoteStep[2].toString(16));
		}
		this.SendFlag(CMJClass.MJGAME_ACTIONSEL, this.m_RemoteStep, ofs);
		this.m_State.SetInt(0, CMJClass.MJSTATE_PLAY);
	}

	private SendActionReadyMsg(md:number):void {
		this.SendFlag(CMJClass.MJGAME_ACTIONSELREADY, this.m_RemoteStep, 0);
		CGame.DebugLog("SendActionReadyMsg");
		var i:number, ci:number;
		var pMP:CMJPlayer = this.m_sPlayers[this.m_Order[this.m_Turn]];
		var pMC:CMJCard;

		for ( i = pMP.m_iPCnt * 3; i <= (CDefine.CARDS_PER_PLAYER - md); i ++ ) {
			pMC = this.m_cCards[pMP.m_Cards[i]];
			ci = this.GetCoordsInfo(i, pMP.m_nPlayerNum, CMJGame.COORD_STAND);
			pMC.SetLocation(ci);
		}
		pMP.SortCards(!md);
	}

	private DoActionSel(buf:CByteArray):void {
		var ofs:number = 0, sel:number, i:number, j:number, s:number, ci:number, k:number, idx:number, icnt:number;
		var bV:number, v:number, tpgh:number, md:number = 0, a:number, gIdx:number;
		var cardI:CByteArray = new CByteArray(18);
		var pMP:CMJPlayer = this.m_sPlayers[this.m_Order[this.m_UserIdx]];
		var pMC:CMJCard;
		
		if ( this.m_cTPGH.GetState() ) this.m_cTPGH.Out();
		if( this.m_MultiThiSel.isVisible() ) this.m_MultiThiSel.reset();

		this.m_State.SetInt(0, CMJClass.MJGAME_ACTIONSEL);
		
		this.m_cCntDown.Reset();
		
		this.m_Turn = buf[ofs++];
		tpgh = buf.GetWord(ofs);
		ofs += 2;
		this.m_OTurn = buf[ofs++];
		pMP = this.m_sPlayers[this.m_Order[this.m_Turn]];
		sel = buf[ofs++];
		
		this.m_cPointer.Show(this.GetPosDir(this.m_Turn));
		
		CGame.DebugLog("DoActionSel:", this.m_Turn, tpgh.toString(16), sel);
		if ( sel == 4 ) {
			this.m_WinTurn = this.m_Turn;
			j = 4;
			pMP.SetTPGH(tpgh);
			if( pMP.GetTPGH() & CDefine.MJ_Z4MO2 ) { 
				pMP.AddTPGH(CDefine.MJ_Z4MO2); j ++; 
				SoundMgr.playVoc("act05");
				// for ( i = 0; i < CDefine.PLAYER_NUMS; i ++ ) {
				// 	if ( this.m_sPlayers[this.m_Order[i]].m_nPlayerNum != pMP.m_nPlayerNum ) 
				// 		m_sPlayers[m_Order[i]].m_Character.SetAct(CMJChar.ACT_BPON, 99999);
				// }
			}
			else {
				SoundMgr.playVoc("act04");
				// pMP.m_Character.SetAct(CMJChar.ACT_HUO);
				// m_sPlayers[m_Order[m_OTurn]].m_Character.SetAct(CMJChar.ACT_BPON, 99999);
			}
			pMP.m_tpState.Show(j, this.m_State, CMJClass.MJSTATE_CHKRESULT);
		}
		else {
			SoundMgr.playVoc("act0"+sel);
			pMP.m_tpState.Show(sel + 1);
			for ( i = 0; i < 18; i ++ ) cardI[i] = i;
			if ( !(tpgh & 0x8000) ) {	// 吃、碰、槓別人的牌
				pMC = this.m_cCards[this.m_CurOutIdx];
				if ( sel == 2 ) { 
					ci = this.GetCoordsInfo(15+pMP.m_iPCnt, pMP.m_nPlayerNum, CMJGame.COORD_TPGH);
					pMC.SetGun(); 
				}
				else {
					ci = this.GetCoordsInfo(pMP.m_iPCnt*3+1, pMP.m_nPlayerNum, CMJGame.COORD_TPGH);
				}
				pMC.ChgLocationImm(ci, 200, 0, 0, 7);
				bV = pMC.GetV();
				if ( sel == 0 ) {
					idx = pMP.m_iPCnt*3+1;
					s = pMP.m_Cards[idx];
					pMP.m_Cards[idx] = this.m_CurOutIdx;
					pMP.m_Cards[CDefine.CARDS_PER_PLAYER] = s;
					cardI[idx] = CDefine.CARDS_PER_PLAYER;
					cardI[CDefine.CARDS_PER_PLAYER] = idx;
				}
				else {
					pMP.m_Cards[CDefine.CARDS_PER_PLAYER] = this.m_CurOutIdx;
				}
				this.m_OutCardCnt += 100;
			}
			if ( sel == 0 ) {
				pMC.SetStatus(5);
				for (j = 0, s = 0; j < 3; j++) {
					i = buf[ofs + j * 2];
					v = buf[ofs + 1 + j * 2];
					if (i == -1 || i == 255) continue;
					pMC = this.m_cCards[pMP.m_Cards[cardI[i]]];
					CGame.DebugLog("***** -> ", i, v, cardI[i], pMC.GetV());
					pMC.SetV(v);
					pMC.SetStatus(5);
					ci = this.GetCoordsInfo(pMP.m_iPCnt*3+s, pMP.m_nPlayerNum, CMJGame.COORD_TPGH);
					pMC.ChgLocationImm(ci, 200, 0, 0, 7);
					idx = pMP.m_iPCnt * 3 + s;
					if (idx != i) {
						a = cardI[idx];
						k = pMP.m_Cards[idx];
						pMP.m_Cards[idx] = pMP.m_Cards[cardI[i]];
						pMP.m_Cards[cardI[i]] = k;
						cardI[idx] = cardI[i];
						cardI[i] = a;
					}
					s += 2;
				}
				pMP.m_OutVal[pMP.m_iPCnt] = bV;
				pMP.m_byPType[pMP.m_iPCnt] = CDefine.MJACTION_THI;
				pMP.m_iPCnt ++;
			}
			else if ( sel == 1 ) {
				pMC.SetStatus(8);
				gIdx = buf[ofs];
				v = buf[ofs + 1];
				for ( i = buf[ofs], icnt = 1, s = 0; i <= CDefine.CARDS_PER_PLAYER; i ++ ) {
					pMC = this.m_cCards[pMP.m_Cards[i]];
					pMC.SetV(v);
					pMC.SetStatus(8);
					ci = this.GetCoordsInfo(pMP.m_iPCnt*3+s, pMP.m_nPlayerNum, CMJGame.COORD_TPGH);
					pMC.ChgLocationImm(ci, 200, 0, 0, 7);
					idx = pMP.m_iPCnt*3+s;
					if( idx != i ) {
						j = pMP.m_Cards[idx];
						pMP.m_Cards[idx] = pMP.m_Cards[i];
						pMP.m_Cards[i] = j;
					}
					s += 2;
					icnt ++;
					if( icnt >= 3 ) break;
				}
				idx = pMP.m_iPCnt * 3 + 1;
				if (idx != CDefine.CARDS_PER_PLAYER) {
					k = pMP.m_Cards[idx];
					pMP.m_Cards[idx] = pMP.m_Cards[CDefine.CARDS_PER_PLAYER];
					pMP.m_Cards[CDefine.CARDS_PER_PLAYER] = k;
				}
				pMP.m_OutVal[pMP.m_iPCnt] = v;
				pMP.m_byPType[pMP.m_iPCnt] = CDefine.MJACTION_PON;
				pMP.m_iPCnt ++;
			}
			else if ( sel == 2 ) {
				let PCnt = pMP.m_iPCnt;
				let st = 9, rn = 0;
				md = 1;
				i = buf[ofs];
				v = buf[ofs + 1];
				gIdx = i;
				if ( (tpgh & 0x8000) ) {	// 槓手中其他牌
					icnt = 1;
					pMC = this.m_cCards[pMP.m_Cards[gIdx]];
					pMC.SetV(v);
					bV = pMC.GetV();
					for( j = 0; j < pMP.m_iPCnt; j ++ ) {
						if( pMP.m_byPType[j] == CDefine.MJACTION_PON && pMP.m_OutVal[j] == bV ) {	// 可以搶槓的牌
							this.m_CurOutIdx = pMP.m_Cards[gIdx]; rn = bV; PCnt = j; 
							this.m_cgIndex = pMP.m_Cards[gIdx];
							CGame.DebugLog("****可以搶槓的牌", this.m_cgIndex);
							icnt += 3;
							break;
						}
					}
					if( rn == 0 ) {
						st = 10;
						if( pMP.m_nPlayerNum == 0 ) pMC.SetStatus(11);
						else						pMC.SetStatus(10);
						pMP.m_iPCnt ++;
					}
					else {
						pMC.SetStatus(9);
						i = PCnt * 3 + 1;
						this.m_cCards[pMP.m_Cards[i]].SetStatus(9);
					}
					ci = this.GetCoordsInfo(15+PCnt, pMP.m_nPlayerNum, CMJGame.COORD_TPGH);
					pMC.SetGun();
					pMC.ChgLocationImm(ci, 200, 0, 0, 7);
					if( gIdx != CDefine.CARDS_PER_PLAYER ) {
						pMP.m_Cards[gIdx] = pMP.m_Cards[CDefine.CARDS_PER_PLAYER];
					}
					if( icnt < 4 ) {
						if ( pMP.m_nPlayerNum == 0 ) {
							for ( i = gIdx, s = 0; i < CDefine.CARDS_PER_PLAYER; i ++ ) {
								pMC = this.m_cCards[pMP.m_Cards[i]];
								if ( pMC.GetV() != v ) continue;
								pMC.SetStatus(st);
								ci = this.GetCoordsInfo(PCnt*3+s, pMP.m_nPlayerNum, CMJGame.COORD_TPGH);
								pMC.ChgLocationImm(ci, 200, 0, 0, 7);
								idx = PCnt*3+s;
								if( idx != i ) {
									j = pMP.m_Cards[idx];
									pMP.m_Cards[idx] = pMP.m_Cards[i];
									pMP.m_Cards[i] = j;
								}
								s ++;
								icnt ++;
								if( icnt >= 4 ) break;
							}
						}
						else {
							for ( i = gIdx, s = 0; i < CDefine.CARDS_PER_PLAYER; i ++ ) {
								pMC = this.m_cCards[pMP.m_Cards[i]];
								pMC.SetV(v);
								pMC.SetStatus(st);
								ci = this.GetCoordsInfo(PCnt*3+s, pMP.m_nPlayerNum, CMJGame.COORD_TPGH);
								pMC.ChgLocationImm(ci, 200, 0, 0, 7);
								idx = PCnt*3+s;
								if( idx != i ) {
									j = pMP.m_Cards[idx];
									pMP.m_Cards[idx] = pMP.m_Cards[i];
									pMP.m_Cards[i] = j;
								}
								s ++;
								icnt ++;
								if( icnt >= 4 ) break;
							}
						}
					}
				}
				else {	//槓別人的牌
					//CGame.DebugLog("槓別人的牌...", buf[ofs]);
					icnt = 1;
					pMC.SetStatus(9);
					pMP.m_iPCnt ++;
					if ( pMP.m_nPlayerNum == 0 ) {
						for ( i = buf[ofs], s = 0; i < CDefine.CARDS_PER_PLAYER; i ++ ) {
							pMC = this.m_cCards[pMP.m_Cards[i]];
							if ( pMC.GetV() != v ) continue;
							pMC.SetStatus(st);
							ci = this.GetCoordsInfo(PCnt*3+s, pMP.m_nPlayerNum, CMJGame.COORD_TPGH);
							pMC.ChgLocationImm(ci, 200, 0, 0, 7);
							idx = PCnt*3+s;
							if( idx != i ) {
								j = pMP.m_Cards[idx];
								pMP.m_Cards[idx] = pMP.m_Cards[i];
								pMP.m_Cards[i] = j;
							}
							s ++;
							icnt ++;
							if( icnt >= 4 ) break;
						}
					}
					else {
						for ( i = buf[ofs], s = 0; i < CDefine.CARDS_PER_PLAYER; i ++ ) {
							pMC = this.m_cCards[pMP.m_Cards[i]];
							pMC.SetV(v);
							pMC.SetStatus(9);
							ci = this.GetCoordsInfo(PCnt*3+s, pMP.m_nPlayerNum, CMJGame.COORD_TPGH);
							pMC.ChgLocationImm(ci, 200, 0, 0, 7);
							idx = PCnt*3+s;
							if( idx != i ) {
								j = pMP.m_Cards[idx];
								pMP.m_Cards[idx] = pMP.m_Cards[i];
								pMP.m_Cards[i] = j;
							}
							s ++;
							icnt ++;
							if( icnt >= 4 ) break;
						}
					}
				}
				pMP.m_OutVal[PCnt] = v;
				pMP.m_byPType[PCnt] = CDefine.MJACTION_GUN;
				pMP.m_Cards[CDefine.CARDS_PER_PLAYER] = 255;
				this.m_CurOutIdx = 254;
			}
			pMP.SetTPGH(0);
			this.HideOutCardBG();
			this.AddDelayCall(250, this.SendActionReadyMsg.bind(this), md);
			CGame.DebugLog("   DoActionSel done.");
		}
	}

	private ProcessUserOperation():void {
		var pMP:CMJPlayer = this.m_sPlayers[this.m_Order[this.m_UserIdx]];
		var sel:number = -1, row:number;

		if( this.m_fgEndGame ) return;
		
		if ( this.m_State.GetInt(0) == CMJClass.MJSTATE_SELCARD ) {
			if ( pMP.isTing() ) sel = CDefine.CARDS_PER_PLAYER;
			if ( this.m_ClickValue != -1 ) {
				if ( sel == -1 ) sel = this.m_ClickValue;
				this.m_ClickValue = -1;
			}

			if ( sel == -1 && this.m_cCntDown.GetStat() <= 0 ) {
				sel = CDefine.CARDS_PER_PLAYER;
			}

			// CONFIG::TimeLimit {
			// 	if ( sel != -1 && this.m_cCntDown.GetStat() < 0 ) {
			// 		if ( this.m_cTPGH.GetState() ) sel = 10005;
			// 		else sel = CDefine.CARDS_PER_PLAYER;
			// 	}
			// }
			if ( sel != -1 ) {
				this.m_cCntDown.Reset();
				if ( sel >= 10000 && sel < 10000 + 6 ) {
					this.m_cTPGH.Out();
					this.m_cCntDown.Show();
					if( sel == 10003 ) {		// 聽
						pMP.m_Flag[1] = 1;
					}
				}
				else {
					CGame.DebugLog("ProcessUserOperation:", sel, this.m_sPlayers[this.m_Order[this.m_UserIdx]].m_Cards[sel]);
					this.m_RemoteStep[0] = sel;
					this.m_RemoteStep[1] = this.m_cCards[this.m_sPlayers[this.m_Order[this.m_UserIdx]].m_Cards[sel]].GetV();
					this.m_RemoteStep[2] = pMP.m_Flag[1];	// 是否按了聽牌
					this.SendFlag(CMJClass.MJGAME_PLAYERCARDOUT, this.m_RemoteStep, 3);
					this.m_State.SetInt(0, CMJClass.MJSTATE_PLAY);
					pMP.m_Flag[1] = 0;
				}
			}
		}
		else if ( this.m_State.GetInt(0) == CMJClass.MJSTATE_TPGH ) {
			if ( pMP.m_bCardIn.GetInt(0) == CDefine.STATE_SEL_THI ) {
				sel = this.m_MultiThiSel.getSel();
				if ( sel != -1 ) this.m_cCntDown.Reset();
			}
			else if ( pMP.m_bCardIn.GetInt(0) == CDefine.STATE_SEL_GUN ) {
				sel = this.m_MultiGunSel.getSel();
				if ( sel != -1 ) this.m_cCntDown.Reset();
			}
			else if ( this.m_ClickValue != -1 ) {
				sel = this.m_ClickValue;
				this.m_ClickValue = -1;
			}
			if ( sel == -1 && this.m_cCntDown.GetStat() <= 0 ) {
				if ( this.m_cTPGH.GetState() ) sel = 10005;
			}
			// CONFIG::TimeLimit {
			// 	if ( sel != -1 && this.m_cCntDown.GetStat() < 0 ) {
			// 		if ( this.m_cTPGH.GetState() ) sel = 10005;
			// 	}
			// }
			if ( sel >= 10000 && sel < 10000 + 6 ) {
				row = sel - 10000;
				this.m_cTPGH.Out();
				this.m_cCntDown.Reset();
				if ( row == 0 ) {
					if ( this.m_MultiThiSel.getCount() > 1 ) {
						this.m_MultiThiSel.show();
						pMP.m_bCardIn.SetInt(0, CDefine.STATE_SEL_THI);
						row = -1;
					}
				}
				else if ( row == 2 ) {
					if ( this.m_MultiGunSel.getCount() > 1 ) {
						this.m_MultiGunSel.show();
						pMP.m_bCardIn.SetInt(0, CDefine.STATE_SEL_GUN);
						row = -1;
					}
				}
				if ( row >= 0 ) {
					this.SendActionSelMsg(row);
				}

				if( row != 5 || this.m_Turn == this.m_UserIdx ) this.m_cCntDown.Show();
			}
			else if ( sel >= 1000 && sel < 1000 + 6 ) {	// 吃
				row = sel - 1000;
				if ( row == 5 ) this.SendActionSelMsg(row);
				else 			this.SendActionSelMsg(0, row);
				this.m_MultiThiSel.reset();
				this.m_cCntDown.Reset();
				this.m_cCntDown.Show();
			}
			else if ( sel >= 2000 && sel < 2000 + 6 ) {	// 槓
				row = sel - 2000;
				if ( row == 5 ) this.SendActionSelMsg(row);
				else 			this.SendActionSelMsg(2, row);
				this.m_MultiGunSel.reset();
				this.m_cCntDown.Reset();
				this.m_cCntDown.Show();
			}
		}
	}

	private onClickResultBtn(e:PIXI.InteractionEvent):void {
		let btn = fgui.GObject.castFromNativeObject(e.currentTarget);
		CGame.DebugLog(btn.name);
		SoundMgr.play("s002");
		if( btn.name == "btn_Continue" ) {
			btn.visible = false;
			if( this.m_ResTween ) createjs.Tween.removeTweens(this.m_ResTween);
			this.m_ResTween = null;
			//CSoundRes.Instance.PlayGameSound(5);
			this.SendFlag(CMJClass.MJGAME_DORESULTREADY, this.m_RemoteStep, 0);
		}
		else if( btn.name == "btn_Share" ) {
		}
		else if( btn.name == "btn_Capture" ) {
			this.mGame.TakeScreenshot();
		}
	}
	private HideResultPanel():void {
		if( this.m_ResTween ) createjs.Tween.removeTweens(this.m_ResTween);
		this.m_ResTween = null;
		this.mGame.SetGObjectCallbackFunc(this.m_mcResult, this.onClickResultBtn, false, this);
		SoundMgr.play("s003");
		createjs.Tween.get(this.m_mcResult)
				.to({y:-CConfig.gameHT}, 250, createjs.Ease.linear)
				.wait(100)
				.to({visible:false});
		this.ResetToShuffleReady();
	}
	private ShowResultPanel():void {
		let btn = this.m_mcResult.getChild("btn_Continue") as fgui.GButton;
		btn.visible = true;
		btn = this.m_mcResult.getChild("btn_Share") as fgui.GButton;
		btn.visible = false;
		btn = this.m_mcResult.getChild("btn_Capture") as fgui.GButton;
		btn.visible = false;

		this.m_mcResult.visible = true;
		this.m_mcResult.y = -CConfig.gameHT;
		SoundMgr.play("s006");
		let that = this;
		this.m_ResTween = createjs.Tween.get(this.m_mcResult)
				.to({y:0}, 250, createjs.Ease.linear)
				.wait(10000)
				.call(function() {
					that.SendFlag(CMJClass.MJGAME_DORESULTREADY, that.m_RemoteStep, 0);
				});
		this.mGame.SetGObjectCallbackFunc(this.m_mcResult, this.onClickResultBtn, true, this);
	}
	private CalcFrame(mcCur:fgui.GMovieClip, Value:number, status:number):void {
		var col = 8, row = 5, frame = 0, tframe = 43;
			
		if ( status && status != 10 ) {
			row = ((Value & 0x70) >> 4);
			col = (Value & 0x0f);
		}
		if ( row < CDefine.MJTYPE_FLOWERS ) frame = (row - 1) * 9 + col;
		else frame = 3 * 9 + 7 + col;
		if ( frame >= 43 ) {
		}
		else {
		}
		mcCur.frame = frame;
    }
	private ShowResult(dealer:number, dt:string):void {
		var i:number, j:number, n:number, score:number, zimo:number = 0;
		var pMP:CMJPlayer;
		var mc:fgui.GMovieClip, mcP:fgui.GMovieClip, mcs:fgui.GMovieClip;
		var mci:fgui.GMovieClip, mcb:fgui.GMovieClip;

		if( this.m_fgResult == false ) { // avatar,name,id 只處理一次
			this.m_fgResult = true;
			n = this.m_UserIdx;
			for ( i = 0; i < CDefine.PLAYER_NUMS; i ++ ) {
				pMP = this.m_sPlayers[this.m_Order[n]];
				if( pMP.GetAvatar() != "none ") {
					let avatar = this.m_mcResult.getChild("avatar"+i) as fgui.GLoader;
					avatar.texture = PIXI.Texture.from(pMP.GetAvatar());
				}
				let t = this.m_mcResult.getChild("txt_Name"+i) as fgui.GTextField;
				t.text = pMP.GetName();
				t = this.m_mcResult.getChild("txt_ID"+i) as fgui.GTextField;
				t.text = "ID:"+pMP.GetDBID();
				n ++;
				n &= 3;
			}
		}
		let t = this.m_mcResult.getChild("txt_Date") as fgui.GTextField;
		t.text = dt;
		// let date = new Date();
		// t.text = date.toLocaleString("ja-JP");
		
		for ( i = 0; i < this.m_mjCoords.length; i += CMJGame.COORD_INFO ) {
			mc = this.m_mjCoords[i] as fgui.GMovieClip;
			mc.visible = false;
		}
		// for( i = 0; i < CDefine.PLAYER_NUMS; i ++ ) {
		// 	this.m_sPlayers[i].m_cntBonus = 0;
		// 	let mccb = this.m_mcResult.getChild("mc_CountBonus"+i) as fgui.GComponent;
		// 	mccb.visible = false;
		// }
		if( (this.m_sPlayers[this.m_Order[this.m_WinTurn]].GetTPGH() & CDefine.MJ_Z4MO2) ) zimo = 1;
		mci = this.m_mcResult.getChild("mc_isDealer0") as fgui.GMovieClip;
		mcs = this.m_mcResult.getChild("mc_HuState") as fgui.GMovieClip;
		mcb = this.m_mcResult.getChild("mc_BeHu") as fgui.GMovieClip;
		mcb.visible = false;
		score = 0;
		let cb = 0;
		CGame.DebugLog("*** m_WinTurn:mTurn:m_OTurn", this.m_WinTurn, this.m_Turn, this.m_OTurn, this.m_sPlayers[this.m_Order[this.m_WinTurn]].GetTPGH().toString(16));
		n = this.m_UserIdx;
		for( i = 0; i < CDefine.PLAYER_NUMS; i ++ ) {
			pMP = this.m_sPlayers[this.m_Order[n]];
			if( this.m_Order[n] == dealer && mci ) {
				mci.x = 66;
				mci.y = 137+i*104;
			}
			//pMP.m_iScore += pMP.m_incSC;
			if( n == this.m_WinTurn ) {
				if( mcs ) {
					if( zimo) mcs.frame = 2;
					else 	  mcs.frame = 0;
					mcs.x = 178;
					mcs.y = 160+i*104;
				}
			}
			else {
				//pMP.m_incSC = -pMP.m_incSC;
				if( pMP.m_incSC != 0 ) {
					pMP.m_cntBonus = -this.m_Core.m_cntHuDealer;
					if( zimo ) {
						if( this.m_Order[n] == dealer ) pMP.m_cntBonus = -this.m_Core.m_cntHu;
					}
					else {
						if( n == this.m_OTurn ) pMP.m_cntBonus = -this.m_Core.m_cntHu;
						if( mcb ) {
							mcb.visible = true;
							mcb.frame = 1;
							mcb.x = 178;
							mcb.y = 160+i*104;
						}
					}
				}
				// if( (this.m_sPlayers[this.m_Order[this.m_WinTurn]].GetTPGH() & CDefine.MJ_Z4MO2) ) {
				// 	pMP.m_incSC = -pMP.m_incSC;
				// }
				// else if( n == this.m_OTurn ) {
				// 	pMP.m_cntBonus = -this.m_Core.m_cntHu;
				// 	pMP.m_incSC = -pMP.m_incSC;
				// 	//CUtil.playMovieClip(m_mcLayout, "mc_BeHu" + m_Order[n]);
				// }
				//pMP.m_iScore += pMP.m_incSC;
				//score -= pMP.m_incSC;
				cb -= pMP.m_cntBonus;
			}
			CGame.DebugLog("    n:m_incSC:score", n, pMP.m_incSC, score, pMP.m_iScore);
			n ++; n &= 3;
		}
		this.m_sPlayers[this.m_Order[this.m_WinTurn]].m_cntBonus = cb;
		//this.m_sPlayers[this.m_Order[this.m_WinTurn]].m_incSC = score;
		//this.m_sPlayers[this.m_Order[this.m_WinTurn]].m_iScore += score;
		
		for ( i = 0; i < CDefine.PLAYER_NUMS; i ++ ) {
			CGame.DebugLog("=====> " + this.m_sPlayers[this.m_Order[i]].m_incSC);
		}
		// ======================== 顯示玩家的牌 ====================================
		n = this.m_UserIdx;
		var m:number, idx:number, show:boolean;
		var pMC:CMJCard;
		for( i = 0; i < CDefine.PLAYER_NUMS; i ++ ) {
			pMP = this.m_sPlayers[this.m_Order[n]];
			// 花牌
			for ( j = 0; j < 8; j ++ ) {
				if ( j < pMP.m_nHuaCnt ) show = true;
				else show = false;
				mcP =this.m_mcResult.getChild("res_P0" + i + "_01_" + j) as fgui.GMovieClip;
				mcP.visible = show;
				if( show )  {
					this.CalcFrame(mcP, pMP.m_Hua1Pai2[j], 1);
				}
			}
			for ( j = 0; j < 22; j ++ ) {
				mc = this.m_mcResult.getChild("res_P0" + i + "_00_" + j) as fgui.GMovieClip;
				mc.visible = false;
			}
			m = CDefine.CARDS_PER_PLAYER;
			if ( pMP.m_bCardIn.GetInt(0) || (pMP.GetTPGH() & CDefine.MJACTION_HUO) ) m ++;
			for( j = 0; j < m; j ++ ) {
				if ( pMP.m_Cards[j] == 255 ) continue;
				mcP = this.m_mcResult.getChild("res_P0" + i + "_00_" + j) as fgui.GMovieClip;
				mcP.visible = true;
				pMC = this.m_cCards[pMP.m_Cards[j]];
				this.CalcFrame(mcP, pMC.GetV(), pMC.GetStatus());
			}
			for ( j = 0; j < pMP.m_iPCnt; j ++ ) {
				m = j*3 + 1;
				mcP = this.m_mcResult.getChild("res_P0" + i + "_00_" + (17 + j)) as fgui.GMovieClip;
				pMC = this.m_cCards[pMP.m_Cards[m]];
				if( pMC.GetStatus() >= 9 ) {	// 槓
					mcP.visible = true;
					this.CalcFrame(mcP, pMC.GetV(), 11);
				}
			}
			n ++; n &= 3;
		}
		// ==========================================================================
		// 算台
		let strRes = "", name = "";
		for( i = 0; i < CMJHuType.MJHUO_MAXMATCH; i ++ ) {
			if ( this.m_Core.m_MJResult[i] ) {
				if ( i == CMJHuType.HU_連 ) {
					j = this.m_Core.m_MJResult[i] / this.m_Core.m_MJConfig[i];
					name = this.m_HUText[i] + j + this.m_HUText[i + 1] + j;
				}
				else 
					name = this.m_HUText[i];
				if( strRes != "" ) strRes += ", ";
				strRes += (name+"("+this.m_Core.m_MJResult[i]+"台)");
			}
		}

		let mccb = this.m_mcResult.getChild("mc_CountBonus0") as fgui.GComponent;
		t = mccb.getChild("txt_Content") as fgui.GTextField;
		t.text = strRes;
		mccb.visible = true;
		// mc = CUtil.ShowDispObject(mcP, "mc_Total", true) as MovieClip;
		// CUtil.setTextFieldInt(mc, "txt_Total", this.m_Core.m_cntHu);
		// 顯示各家資訊
		n = this.m_UserIdx;
		for ( i = 0; i < CDefine.PLAYER_NUMS; i ++ ) {
			pMP = this.m_sPlayers[this.m_Order[n]];
			pMP.PlusGValue(pMP.m_incSC);
			let t = this.m_mcResult.getChild("txt_Score"+i) as fgui.GTextField;
			let ic = pMP.m_incSC / CDefine.GOLD_MULTI_BASE;
			if ( pMP.m_incSC > 0 ) {
				t.text = "+" + ic.toFixed(1);
				// let mccb = this.m_mcResult.getChild("mc_CountBonus"+i) as fgui.GComponent;
				// t = mccb.getChild("txt_Content") as fgui.GTextField;
				// t.text = strRes;
				// mccb.visible = true;
			}
			else {
				t.text = ''+ic.toFixed(1);
			}
			t = this.m_mcResult.getChild("txt_BCount"+i) as fgui.GTextField;
			if ( pMP.m_cntBonus > 0 ) {
				t.text = "+" + pMP.m_cntBonus;
			}
			else {
				t.text = ''+pMP.m_cntBonus;
			}
			// CUtil.ShowDispObject(mc, "mc_ZiMo", false);
			// CUtil.ShowDispObject(mc, "mc_Hu", false);
			// CUtil.ShowDispObject(mc, "mc_BeHu", false);
			// if ( n == this.m_WinTurn ) {
			// 	if( this.m_sPlayers[this.m_Order[this.m_WinTurn]].GetTPGH() & CDefine.MJ_Z4MO2 ) 
			// 		CUtil.ShowDispObject(mc, "mc_ZiMo", true);
			// 	else 
			// 		CUtil.ShowDispObject(mc, "mc_Hu", true);
			// }
			// else if ( n == this.m_OTurn && (this.m_sPlayers[this.m_Order[this.m_WinTurn]].GetTPGH() & CDefine.MJ_Z4MO2) == 0 ) {
			// 	CUtil.ShowDispObject(mc, "mc_BeHu", true);
			// }
			n ++;
			n &= 3;
		}
		this.ShowResultPanel();
	}
	private EndPrepareResult(v:number):void {
		CGame.DebugLog("EndPrepareResult:", v);
		this.SendFlag(CMJClass.MJGAME_PREPARERESULTREADY, this.m_RemoteStep, 0);
		let mc = this.mainView.getChild("mc_Draw00") as fgui.GImage;
		mc.visible = false;
	}
	private PrepareResult(size:number, buf:CByteArray):void {
		var type:number = buf[0];
		CGame.DebugLog("MJGAME_PREPARERESULT:", size, type);
		var i:number, j:number, n:number, fgOpen:number, ofs:number, v:number;
		var oTurn:number, fgCardIn:number, winTurn:number;
		var pMC:CMJCard;
		var pMP:CMJPlayer;
		
		if ( type == CDefine.GEND_LIU2JU2 ) this.FinishPutCard();
		
		this.ShowSkipHu(false);

		this.m_firstCardReady = false;
		this.m_State.SetInt(0, CMJClass.MJSTATE_PRERESULT);

		this.HideOutCardBG();
		this.m_cPointer.Show(-1);
		
		ofs = 0;
		type = buf[ofs++];
		winTurn = buf[ofs++];
		oTurn = buf[ofs++];
		fgCardIn = buf[ofs++];
		let tpgh = buf.GetWord(ofs);
		CGame.DebugLog("==== tpgh:", tpgh.toString(16));
		if( type != CDefine.GEND_LIU2JU2 ) {
			pMP = this.m_sPlayers[this.m_Order[this.m_WinTurn]];
			pMP.SetTPGH(tpgh);
		}
		ofs += 2;
		for ( i = 0; i < CDefine.PLAYER_NUMS; i ++ ) {
			for ( j = 0; j < CDefine.CARDS_PER_PLAYER; j ++ ) {
				v = buf[ofs++];
				n = this.m_sPlayers[i].m_Cards[j];
				if ( this.m_cCards[n].GetStatus() >= 5 ) continue;
				this.m_cCards[n].SetV(v);
			}
		}
		
		this.m_EndFlag = type;
		if ( type == CDefine.GEND_HUO ) {
			this.m_WinTurn = winTurn;
			this.m_OTurn = oTurn;
			pMP = this.m_sPlayers[this.m_Order[this.m_WinTurn]];
			pMP.m_fgCardIn = fgCardIn;
			if( !(pMP.GetTPGH() & CDefine.MJACTION_HUAHUO) && pMP.m_fgCardIn == 0 ) {
				if( pMP.GetTPGH() & CDefine.MJACTION_HUCG ) {
					pMC = this.m_cCards[this.m_cgIndex];
					pMP.m_Cards[CDefine.CARDS_PER_PLAYER] = this.m_cgIndex;
				}
				else {
					pMC = this.m_cCards[this.m_CurOutIdx];
					pMP.m_Cards[CDefine.CARDS_PER_PLAYER] = this.m_CurOutIdx;
				}
				if( pMC.GetStatus() >= 9 ) {
					pMC.SetStatus(1);
					var pOMP:CMJPlayer = this.m_sPlayers[this.m_Order[this.m_OTurn]];
					for( i = 0; i < CDefine.CARDS_PER_PLAYER; i ++ ) {
						if( this.m_cCards[pOMP.m_Cards[i]].GetV() == pMC.GetV() ) {
							if( this.m_cCards[pOMP.m_Cards[i]].GetStatus() >= 9 ) 
							this.m_cCards[pOMP.m_Cards[i]].SetStatus(8);
						}
					}
				}
				ofs = this.GetCoordsInfo(CDefine.CARDS_PER_PLAYER, pMP.m_nPlayerNum, CMJGame.COORD_OPEN);
				pMC.ChgLocation(ofs, 200, 0, 0, 7);
				// pMP.m_Cards[CDefine.CARDS_PER_PLAYER] = this.m_CurOutIdx;
			}
			//else if ( (pMP.GetTPGH() & CEnumTypes.MJACTION_HUAHUO) && pMP.m_fgCardIn ) {
			else if( pMP.m_fgCardIn ) {
				//CSoundRes.Instance.PlayGameSound(12);
				pMC = this.m_cCards[pMP.m_Cards[CDefine.CARDS_PER_PLAYER]];
				ofs = this.GetCoordsInfo(CDefine.CARDS_PER_PLAYER, pMP.m_nPlayerNum, CMJGame.COORD_OPEN);
				fgOpen = 0;
				if( pMC.GetStatus() == 0 ) fgOpen = 1;
				pMC.ChgLocation(ofs, 20, 0, fgOpen);
			}
			this.AddDelayCall(3000, this.EndPrepareResult.bind(this));
		}
		else {
			for ( i = 0; i < CDefine.PLAYER_NUMS; i ++ ) this.m_sPlayers[i].ShowTing(false);
			this.mGame.PlayTransition(this.mainView, "Draw0", this.EndPrepareResult.bind(this));
			this.m_Turn = this.m_idxDealer;
		}
		for( i = 0; i < CDefine.PLAYER_NUMS; i ++ ) {
			pMP = this.m_sPlayers[i];
			n = CDefine.CARDS_PER_PLAYER;
			if( pMP.m_bCardIn.GetInt(0) ) n ++;
			for( j = pMP.m_iPCnt*3; j < n; j ++ ) {
				if( pMP.m_Cards[j] == 255 ) continue;
				pMC = this.m_cCards[pMP.m_Cards[j]];
				ofs = this.GetCoordsInfo(j, pMP.m_nPlayerNum, CMJGame.COORD_OPEN);
				fgOpen = 0;
				if( pMC.GetStatus() == 0 ) fgOpen = 1;
				pMC.ChgLocation(ofs, 20, 0, fgOpen);
			}
		}
	}
	private DoResult(size:number, buf:CByteArray):void {
		var i:number, ofs:number = 0;
		CGame.DebugLog("DoResult:", size, buf[0], buf[1], buf[2]);
		let dealer = this.m_Dealer;
		this.m_idxDealer = buf[ofs++];
		this.m_DealerCnt = buf[ofs++];
		this.m_RoundWind = buf[ofs++];
		this.m_Dealer = this.m_Order[this.m_idxDealer];
		if( size < 5 ) {
			let gv = buf[ofs++];
			if( gv == 0 )
				this.ResetToShuffleReady();
			else 
				this.SendFlag(CMJClass.MJGAME_DORESULTREADY, this.m_RemoteStep, 0);
		}
		else {
			this.m_Core.m_cntHu = buf[ofs++];
			this.m_Core.m_cntHuDealer = buf[ofs++];
			for (i = 0; i < CDefine.PLAYER_NUMS; i++) {
				this.m_sPlayers[this.m_Order[i]].m_incSC = buf.GetInt(ofs);
				ofs += 4;
			}
			// this.m_Core.m_MJResult.Copy(0, buf, ofs, size-ofs);
			this.m_Core.m_MJResult.Copy(0, buf, ofs, this.m_Core.m_MJResult.length);
			ofs += this.m_Core.m_MJResult.length;
			let dt:string = buf.GetUTFBytes(ofs, 24);
			this.ShowResult(dealer, dt);
		}
	}
	private FinalResult():void {
		var n:number, i:number;
		var pMP:CMJPlayer;

		let t = this.m_mcFinalResult.getChild("txt_Date") as fgui.GTextField;
		let date = new Date();
		t.text = date.toLocaleString("ja-JP");
		t = this.m_mcFinalResult.getChild("txt_RoomNumber") as fgui.GTextField;
		t.text = "房號:"+this.mGame.m_clTable.idxTable;
		t = this.m_mcFinalResult.getChild("txt_Rule") as fgui.GTextField;
		t.text = "底:"+this.mGame.m_clTable.Base+", 台:" + this.mGame.m_clTable.Bonus;
		// if( this.mGame.m_clTable.Cost == 0 )
		// 	t.text += "玩家均攤";
		// else 
		// 	t.text += "房主負擔";
		for ( i = 0; i < CDefine.PLAYER_NUMS; i ++ ) {
			pMP = this.m_sPlayers[this.m_Order[i]];
			let com = this.m_mcFinalResult.getChild("com_Player"+i) as fgui.GComponent;
			if( pMP.GetAvatar() != "none" ) {
				let avatar = com.getChild("avatar") as fgui.GLoader;
				avatar.texture = PIXI.Texture.from(pMP.GetAvatar());
			}
			let t = com.getChild("txt_Name") as fgui.GTextField;
			t.text = pMP.GetName();
			t = com.getChild("txt_ID") as fgui.GTextField;
			t.text = "ID:"+pMP.GetDBID();
			let mc = com.getChild("mc_Rank") as fgui.GMovieClip;
			mc.frame = i;
			t = com.getChild("txt_cntZimo") as fgui.GTextField;
			t.text = ""+pMP.m_cntZimo;
			t = com.getChild("txt_cntHu") as fgui.GTextField;
			t.text = ""+pMP.m_cntHu;
			t = com.getChild("txt_cntBeHu") as fgui.GTextField;
			t.text = ""+pMP.m_cntBeHu;
			t = com.getChild("txt_Score") as fgui.GTextField;
			let sc = pMP.m_iScore / CDefine.GOLD_MULTI_BASE;
			t.text = ""+sc.toFixed(1);
		}
	}
	private onClickFinalResultBtn(e:PIXI.InteractionEvent):void {
		let btn = fgui.GObject.castFromNativeObject(e.currentTarget);
		CGame.DebugLog(btn.name);
		SoundMgr.play("s002");
		if( btn.name == "btn_toLobby" ) {
			this.HideFinalResultPanel();
		}
		else if( btn.name == "btn_Share" ) {
		}
		else if( btn.name == "btn_Capture" ) {
			this.mGame.TakeScreenshot();
		}
	}
	private HideFinalResultPanel():void {
		this.m_tmBack2Lobby = 0;
		this.mGame.SetGObjectCallbackFunc(this.m_mcFinalResult, this.onClickFinalResultBtn, false, this);
		SoundMgr.play("s003");
		var that = this;
		createjs.Tween.get(this.m_mcFinalResult)
				.to({y:-CConfig.gameHT}, 250, createjs.Ease.linear)
				.wait(100)
				.call(function(){
					that.DoGameOver();
				});
	}
	private ShowFinalResultPanel():void {
		let d = new Date();
		this.m_tmBack2Lobby = d.getTime();
		//this.mGame.DisconnectServer(1);
		let btn = this.m_mcFinalResult.getChild("btn_Share") as fgui.GButton;
		btn.visible = false;
		btn = this.m_mcFinalResult.getChild("btn_Capture") as fgui.GButton;
		btn.visible = false;

		this.m_mcFinalResult.visible = true;
		this.m_mcFinalResult.y = -CConfig.gameHT;
		SoundMgr.play("s014");
		createjs.Tween.get(this.m_mcFinalResult)
				.to({y:0}, 250, createjs.Ease.linear);
		this.mGame.SetGObjectCallbackFunc(this.m_mcFinalResult, this.onClickFinalResultBtn, true, this);
	}
	private PreGameOver():void {
		var i:number, sc:number, who:number, ofs:number = 0;
		
		CGame.DebugLog("DoGameOver", this.m_WorkBuf[ofs]);
		
		this.m_fgEndGame = this.m_WorkBuf[ofs++];
		who = this.m_WorkBuf[ofs++];
		for( i = 0; i < CDefine.PLAYER_NUMS; i ++ ) this.m_Order[i] = this.m_WorkBuf[ofs++];
		for( i = 0; i < CDefine.PLAYER_NUMS; i ++ ) {
			sc = this.m_WorkBuf.GetInt(ofs); ofs += 4;
			CGame.DebugLog(this.m_sPlayers[i].m_iScore, ":", sc);
			this.m_sPlayers[i].m_iScore = sc;
			this.m_sPlayers[i].m_cntZimo = this.m_WorkBuf.GetShort(ofs); ofs += 2;
			this.m_sPlayers[i].m_cntHu = this.m_WorkBuf.GetShort(ofs); ofs += 2;
			this.m_sPlayers[i].m_cntBeHu = this.m_WorkBuf.GetShort(ofs); ofs += 2;
		}
		this.FinalResult();
		if( this.m_fgEndGame == CEnumTypes.ENDGAME_NORMAL ) this.ShowFinalResultPanel();
		else if( this.m_fgEndGame == CEnumTypes.ENDGAME_TIMEOUT || this.m_fgEndGame == CEnumTypes.ENDGAME_DISCONNECT ) {
			this.mGame.ShowDialog("", "有人離線("+this.m_sPlayers[who].GetName()+")，即將結束牌局！", ["確定"], this.ShowFinalResultPanel.bind(this));
		}
		else if( this.m_fgEndGame == CEnumTypes.ENDGAME_BASELIMIT ) {
			this.mGame.ShowDialog("", "有人("+this.m_sPlayers[who].GetName()+")剩餘金額不足，即將結束牌局！", ["確定"], this.ShowFinalResultPanel.bind(this));
		}
		else if( this.m_fgEndGame == CEnumTypes.ENDGAME_DISMISS ) {
			this.mGame.ShowDialog("", this.m_sPlayers[who].GetName()+"發起解散房間成立，即將結束牌局！", ["確定"], this.ShowFinalResultPanel.bind(this));
		}
	}
	private HidePlayersAnsDismiss():void {
		for( let i = 0; i < CDefine.PLAYER_NUMS; i ++ ) {
			this.m_sPlayers[i].updateAnsDismiss(false);
		}
	}
	// 詢問其他玩家中…   玩家中有人不想解散
	private onAnsDismissDlg(result:boolean):void {
		if( result ) this.m_RemoteStep[0] = CEnumTypes.DISMISS_YES;
		else 		 this.m_RemoteStep[0] = CEnumTypes.DISMISS_NO;
		this.SendFlag(CMJClass.MJGAME_FEEDBACK_DISMISS, this.m_RemoteStep, 1);
		if( result ) this.mGame.ShowDialog("解散房間", "詢問其他玩家中… ", []);
	}
	private DoGameOver():void {
		createjs.Tween.removeAllTweens();
		//CSoundRes.Instance.StopSound();
		this.BackToLobby();
	}

	private BackToLobby():void {
		this.mGame.resetPacket();
		this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_GAME_SESSION);
		this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_LEAVE_GAME);
		this.mGame.SendReliableData(this.mGame.m_CPkt);
		this.mGame.ChangeState(CMJLobby.Instance);
		// this.mGame.DisconnectServer();
		// this.mGame.Back2Web();
		// window.location.href = CConfig.webURL;
		// window.location.replace(CConfig.webURL);
	}

	private onLoginGameServer():void {
		var i:number, n:number;
		for( i = 0; i < CDefine.PLAYER_NUMS; i ++ ) {
			this.m_Order[i] = i;
			this.m_sPlayers[i].Init(i, this);
			this.m_sPlayers[i].m_nWind = i;
			if ( this.mGame.m_pUserPlayer.DBID == this.m_GTable.player[i].DBID ) {
				this.m_UserIdx = i;
			}
		}
		CGame.DebugLog(this.mGame.m_pUserPlayer.DBID, this.m_UserIdx);
		n = this.m_UserIdx;
		for ( i = 0; i < CDefine.PLAYER_NUMS; i ++ ) {
			CGame.DebugLog(this.m_Order[n]);
			this.m_sPlayers[this.m_Order[n]].SetPlayerNum(i);
			this.m_sPlayers[this.m_Order[n]].UpdateInfo(true);
			n ++;
			n &= 3;
		}
		//m_cCntDown.SetSec(m_gMsg.m_GameTBL.Rule_Secs());
		//CSoundRes.Instance.PlayMusFile(m_MusName);
		for ( i = 0; i < 4; i ++ ) {
			this.m_sPlayers[i].DisplayDealer(-1);
		}
	}

	private RecvReConnectData(p:CByteArray):void {
		let i :number;

		this.m_ClickValue = -1;
		//m_mcMOver = null;
		this.m_CardRemain = 0;
		this.m_gTingFlag = 0;
		this.m_OTurn = -1;
		this.m_EndFlag = 0;
		this.m_RemoteIdx = 0;
		this.m_RemoteStep.Reset(0);
		for( i = 0; i < CDefine.PLAYER_NUMS; i ++ ) {
			this.m_sPlayers[i].Reset();
		}
		this.m_ocFlag.Reset();
		this.m_CurOutIdx = 254;
		this.m_OutCardCnt = 0;
		this.m_fgTPGHWait = 0;

		// short		m_CardRemain;
		this.m_CardRemain = p.readShort();
		// short		m_CurCard;		// 摸牌位置索引
		this.m_CurCard = p.readShort();
		// short		m_LastCard;		// 後摸位置索引
		this.m_LastCard = p.readShort();
		// unsigned char		m_CurOutV;	// 目前打出的牌
		p.readByte();
		// char		m_Round;
		p.readByte();
		// char		m_Wind;
		p.readByte();
		// char		m_WinTurn;
		this.m_WinTurn = p.readByte();
		// char		m_Order[PLAYER_NUMS];
		p.readBytes(this.m_Order, 0, CDefine.PLAYER_NUMS);
		// short		m_Turn, m_OTurn;
		this.m_Turn = p.readShort();
		this.m_OTurn = p.readShort();
		// short		m_StartDealer;	// 起莊
		this.m_StartDealer = p.readShort();
		// short		m_RoundWind;	// 圈風
		this.m_RoundWind = p.readShort();
		// short		m_Dealer;		// 莊家
		this.m_Dealer = p.readShort();
		// short		m_DealerCnt;	// 連莊記數
		this.m_DealerCnt = p.readShort();
		// short		m_idxDealer;
		this.m_idxDealer = p.readShort();
		// unsigned char		m_Dice[3];
		p.readBytes(this.m_Dice, 0, 3);
		// short		m_DiceNum;
		this.m_DiceNum = p.readShort();

		let j:number, k:number, fg:number, curCard:number, lastCard:number, index:number, ofs:number;
		let ocards:CByteArray = new CByteArray(20);
		let fgcards:CByteArray = new CByteArray(20);
		let cards:CByteArray = new CByteArray(CDefine.CARDS_PER_PLAYER + 2);
		let status:CByteArray = new CByteArray(CDefine.CARDS_PER_PLAYER + 2);
		let pMP:CMJPlayer;

		let col = CDefine.TOTAL_MJ_CARDS / (2*4);
		let st = this.GetPosDir(this.m_StartDealer, 1);
		j = 0;
		for ( i = 0; i < CDefine.TOTAL_MJ_CARDS; i ++ ) {
			ofs = this.GetCoordsInfo((i >> 1) % col, st, CMJGame.COORD_GETUP + (i & 1));
			this.m_cCards[i].SetV(255, ofs);
			j ++;
			if( j >= (col*2) ) { 
				j = 0; 
				st --;
				if( st < 0 ) st += 4; 
			}
		}

		index = this.m_CurCard - 1;
		if( index < 0 ) index += CDefine.TOTAL_MJ_CARDS;
		k = this.m_LastCard + 1;
		if( k >= CDefine.TOTAL_MJ_CARDS ) k = 0;
		while(1) {
			this.m_cCards[index].GetMC().visible = false;
			index --;
			if( index < 0 ) index += CDefine.TOTAL_MJ_CARDS;
			if( index == k ) break;
		}

		index = this.m_LastCard;
		for ( i = 0; i < 16; i ++ ) {
			this.m_cCards[index].SetLast();
			if( index & 1 ) {
				index -= 3;
				if( index < 0 ) index += CDefine.TOTAL_MJ_CARDS;
			}
			else {
				index ++;
				if( index >= CDefine.TOTAL_MJ_CARDS ) index = 0;
			}
		}

		curCard = this.m_CurCard;
		lastCard = this.m_LastCard;

		i = (this.m_DiceNum + this.m_idxDealer - 1) & 3;
		k = i;
		j = k;
		if (k & 1) j = (k + 2) & 3;
		curCard = j * (CDefine.TOTAL_MJ_CARDS / 4) + this.m_DiceNum * 2;
		if (curCard >= CDefine.TOTAL_MJ_CARDS) curCard = 0;
		lastCard = curCard - 2;
		if (lastCard < 0) lastCard += CDefine.TOTAL_MJ_CARDS;

		for ( i = 0; i < 4; i ++ ) {
			if ( this.mGame.m_pUserPlayer.DBID == this.m_GTable.player[this.m_Order[i]].DBID ) {
				this.m_UserIdx = i;
				break;
			}
		}
		CGame.DebugLog("Order:", this.m_Order);
		CGame.DebugLog("m_UserIdx:", this.m_UserIdx);
		j = this.m_UserIdx;
		for( i = 0; i < 4; i ++ ) {
			this.m_sPlayers[this.m_Order[j]].SetPlayerNum(i);
			j ++; j &= 3;
		}

		function getCard(bfLast:boolean):number {
			let index:number = 0;

			if( !bfLast ) {
				index = curCard ++;
				if( curCard >= CDefine.TOTAL_MJ_CARDS ) curCard = 0;
			}
			else {
				index = lastCard;
				if( lastCard & 1 ) {
					lastCard -= 3;
					if( lastCard < 0 ) lastCard += CDefine.TOTAL_MJ_CARDS;
				}
				else {
					lastCard ++;
					if( lastCard >= CDefine.TOTAL_MJ_CARDS ) lastCard = 0;
				}
			}
			return index;
		}

		for( i = 0; i < CDefine.PLAYER_NUMS; i ++ ) {
			pMP = this.m_sPlayers[i];
			// unsigned char	m_Hua1Pai2[8];		// 已有的花牌
			p.readBytes(pMP.m_Hua1Pai2, 0, 8);
			// short			m_nHuaCnt;			// 花牌計數
			pMP.m_nHuaCnt = p.readShort();
			// int				m_iPCnt;			// 吃碰槓的次數
			pMP.m_iPCnt = p.readInt();
			// unsigned char	m_CPKVal[10];		// 吃碰槓的牌
			p.readBytes(pMP.m_OutVal, 0, 10);
			// unsigned char	m_byPType[10];
			p.readBytes(pMP.m_byPType, 0, 10);
			// short			m_nWind;			// 門風
			pMP.m_nWind = p.readShort();
			// char			m_fsTing;			// 已喊聽牌
			let t = p.readByte();
			if( t ) pMP.ShowTing(true);
			// unsigned char	m_LastPonV;			// 上輪取消碰的牌
			pMP.m_LastPonV = p.readByte();
			// unsigned char	m_LimitCardOut[2];	// 禁止打出與剛吃碰槓牌有關的牌
			p.readBytes(pMP.m_LimitCardOut, 0, 2);
			// short			m_cntZimo, m_cntHu, m_cntBeHu;
			pMP.m_cntZimo = p.readShort();
			pMP.m_cntHu = p.readShort();
			pMP.m_cntBeHu = p.readShort();
			// int				m_incSC, m_Score;
			pMP.m_incSC = p.readInt();
			pMP.m_iScore = p.readInt();
			// short			m_nOutC;				// 目前打出手牌的索引
			pMP.m_nOutC = p.readShort();
			// short			m_nOutCnt;				// 已打出幾支牌
			pMP.m_nOutCnt = p.readShort();
			// unsigned char	m_OutCards[20];			// 打出到海底的牌
			p.readBytes(ocards, 0, 20);
			// short			m_bCardIn;
			pMP.m_fgCardIn = p.readShort();
			// char			m_huoSkip;	// 過水
			pMP.m_huoSkip = p.readByte();
			// char			m_OrderIdx;
			p.readByte();
			// char 			Cards[CARDS_PER_PLAYER+2];
			p.readBytes(pMP.m_Cards, 0, CDefine.CARDS_PER_PLAYER + 2);
			// char 			Status[CARDS_PER_PLAYER+2];
			p.readBytes(status, 0, CDefine.CARDS_PER_PLAYER + 2);

			// =======================================================================================
			// 使用牌─站0, 倒1, 花牌2, 吃碰牌3, 捨棄4
			// =======================================================================================
			//public GetCoordsInfo(index:number, iGP:number, ln:number):number {
			for( j = 0; j < pMP.m_nHuaCnt; j ++ ) {
				index = getCard(true);
				// index = curCard ++;
				// if( curCard >= CDefine.TOTAL_MJ_CARDS ) curCard = 0;
				ofs = this.GetCoordsInfo(j, pMP.m_nPlayerNum, CMJGame.COORD_HUA);
				this.m_cCards[index].SetV(pMP.m_Hua1Pai2[j]);
				this.m_cCards[index].SetStatus(1);
				// CGame.DebugLog("HUA:", pMP.m_Hua1Pai2[j]);
				this.m_cCards[index].SetLocation(ofs);
			}
			for( j = 0; j < pMP.m_nOutCnt; j ++ ) {
				index = getCard(false);
				// index = curCard ++;
				// if( curCard >= CDefine.TOTAL_MJ_CARDS ) curCard = 0;
				ofs = this.GetCoordsInfo(j, pMP.m_nPlayerNum, CMJGame.COORD_PUTOUT);
				this.m_cCards[index].SetV(ocards[j], ofs);
				this.m_cCards[index].SetStatus(1);
				// CGame.DebugLog("OUT:", ocards[j]);
				this.m_cCards[index].SetLocation(ofs, true);
			}
			CGame.DebugLog("m_fgCardIn:", pMP.m_fgCardIn);
			//this.m_sPlayers[this.m_Order[this.m_UserIdx]];
			let m = CDefine.CARDS_PER_PLAYER;
			if ( pMP.m_fgCardIn ) m ++;
			for( j = 0; j < m; j ++ ) {
				// if(status[j] >= 9) index = getCard(true);
				// else 			   index = getCard(false);
				index = getCard(false);
				// index = curCard ++;
				// if( curCard >= CDefine.TOTAL_MJ_CARDS ) curCard = 0;
				if( j < pMP.m_iPCnt*3 ) {
					ofs = this.GetCoordsInfo(j, pMP.m_nPlayerNum, CMJGame.COORD_TPGH);
					k = 1;
				}
				else {
					ofs = this.GetCoordsInfo(j, pMP.m_nPlayerNum, CMJGame.COORD_STAND);
					k = 0;
				}
				this.m_cCards[index].SetV(pMP.m_Cards[j]);
				if( i == this.m_Order[this.m_UserIdx] || k ) {
					if( status[j] == 0 ) status[j] = 1;
				}
				else {
					// this.m_cCards[index].SetV(255, ofs);
				}
				this.m_cCards[index].SetStatus(status[j]);
				this.m_cCards[index].SetLocation(ofs);
				pMP.m_Cards[j] = index;
			}
			for( j = 0; j < pMP.m_iPCnt; j ++ ) {
				if(status[j*3] >= 9) {
					index = getCard(true);
					ofs = this.GetCoordsInfo(15+j, pMP.m_nPlayerNum, CMJGame.COORD_TPGH);
					if( i == this.m_Order[this.m_UserIdx] ) {
						status[j*3] = 11;
					}
					this.m_cCards[index].SetV(this.m_cCards[pMP.m_Cards[j*3]].GetV());
					this.m_cCards[index].SetStatus(status[j*3]);
					this.m_cCards[index].SetLocation(ofs);
					CGame.DebugLog("*** cardV status:", pMP.m_Cards[j*3].toString(16), status[j*3]);
					// pMP.m_Cards[j] = index;
				}
			}
		}

		for( i = 0; i < 4; i ++ ) {
			this.m_sPlayers[this.m_Order[i]].UpdateInfo(true, this.m_Order[i]);
		}
		if( this.m_OTurn >= 0 ) {
			pMP = this.m_sPlayers[this.m_Order[this.m_OTurn]];
			this.m_CurOutIdx = pMP.m_Cards[pMP.m_nOutC];
		}
		pMP = this.m_sPlayers[this.m_Order[this.m_UserIdx]];
		if( pMP.m_fgCardIn && this.m_State.GetInt(0) != CMJClass.MJSTATE_SELCARD ) {
			this.m_State.SetInt(0, CMJClass.MJSTATE_SELCARD);
		}

		this.mGame.HideDialog();
	}

	private SyncCardsCheck():void {
		let buf = this.m_WorkBuf;
		let size = this.m_WorkBuf.size;
		let pMP:CMJPlayer = this.m_sPlayers[this.m_Order[this.m_UserIdx]];
		let i:number, v:number;
		for( i = 0; i < size; i ++ ) {
			v = this.m_cCards[pMP.m_Cards[i]].GetV();
			if( buf[i] != v ) {
				CGame.DebugLog("======= Error:", i, buf[i].toString(16), v.toString(16));
			}
		}
		CGame.DebugLog("SyncCardsCheck Done. ");
	}

	private onRecvGameStepMsg(subType:number):void {
		let buf = this.m_WorkBuf;
		let size = this.m_WorkBuf.size;
		let ofs = 0;
		let i = 0;
		if ( subType == CMJClass.MJGAME_DECIDESEAT ) {
			//m_WaitState = 0;
			for ( i = 0; i < CDefine.PLAYER_NUMS; i ++ ) this.m_sPlayers[i].m_Flag[0] = 0;
			this.PreDecideSeat();
		}
		else if ( subType == CMJClass.MJGAME_SHUFFLE ) {
			CGame.DebugLog("MJGAME_SHUFFLE");
			this.m_RoundWind = buf[ofs];
			this.m_idxDealer = buf[ofs+1];
			for( i = 0; i < CDefine.PLAYER_NUMS; i ++ ) this.m_sPlayers[i].m_Flag[0] = 0;
			for ( i = 0; i < 3; i ++ ) this.m_Dice[i] = buf[ofs + i + 2];
			SoundMgr.playVoc(sprintf("v%03d", 1 + (this.m_RoundWind & 3) * 4 + this.m_idxDealer))
			this.m_cSWind.Set(this.m_RoundWind & 3, this.m_idxDealer, this.Shuffle.bind(this));
			for( i = 0; i < 4; i ++ ) {
				this.m_sPlayers[this.m_Order[i]].DisplayDealer(this.m_Order[i]);
			}
			// ============== new add ========================
			let wind = ["東", "南", "西", "北"];
			let t = this.mainView.getChild("txt_RoomNumber") as fgui.GTextField;
			t.text = "房號: " + this.mGame.m_clTable.idxTable+", "+wind[this.m_RoundWind & 3]+"風"+wind[this.m_idxDealer];
			//CSoundRes.Instance.PlayGameSound(6);
		}
		else if ( subType == CMJClass.MJGAME_CHECKFLOWER ) {
			CGame.DebugLog("MJGAME_CHECKFLOWER_S:", size);
			let n = 0;
			let idx = 100;
			for ( i = 0; i < size; i += 4 ) {
				if ( idx != buf[i] ) {
					n += 100;
					if ( idx != 100 ) this.m_sPlayers[this.m_Order[idx&3]].SortCards();
				}
				idx = buf[i];
				CGame.DebugLog("--->", buf[i], buf[i+1], buf[i+2].toString(16), buf[i+3].toString(16));
				this.Bu3Hua1(this.m_sPlayers[this.m_Order[idx&3]], buf[i + 1], buf[i + 2], buf[i + 3], n);
			}
			if ( idx != 100 ) this.m_sPlayers[this.m_Order[idx&3]].SortCards();
			// ============ change 
			SoundMgr.play("s009");
			this.m_MySprite.Show("mc_Flower", 2500, 0, this.DoCheckFlowerE.bind(this));
			CGame.DebugLog("m_CRFlower.Show ..");
		}
		else if ( subType == CMJClass.MJGAME_PLAYERCARDIN ) {
			CGame.DebugLog("MJGAME_PLAYERCARDIN:", size, buf[0], buf[1], buf[2].toString(16));
			if ( this.m_State.GetInt(0) == CMJClass.MJSTATE_FIRSTCARDALLREADY ) {
				this.m_State.SetInt(0, CMJClass.MJSTATE_PLAY);
				this.m_Turn = buf[0];
				this.m_cPointer.Show(this.GetPosDir(this.m_Turn));
			}
			else {
				this.FinishPutCard();
			}
			let pMP = this.m_sPlayers[this.m_Order[this.m_Turn]];
			if ( buf[1] == 1 ) //&& m_sPlayers[m_Order[m_Turn]].m_Cards[CEnumTypes.CARDS_PER_PLAYER] != 255 ) 
				this.Bu3Hua1(pMP, CDefine.CARDS_PER_PLAYER, this.m_cCards[pMP.m_Cards[CDefine.CARDS_PER_PLAYER]].GetV(), buf[2], 0, this.PlayerCardIn.bind(this));
			else 			
				this.GetCardIn(pMP, buf[2], CDefine.CARDS_PER_PLAYER, buf[1]!=0, 0, this.PlayerCardIn.bind(this));
		}
		else if ( subType == CMJClass.MJGAME_WAITCARDOUT ) {
			this.m_cCntDown.Show();
			this.m_State.SetInt(0, CMJClass.MJSTATE_SELCARD);
			let fgTing = buf[1];
			if ( size > 2 ) {
				this.m_sPlayers[this.m_Order[this.m_UserIdx]].m_LimitCardOut[0] = buf[2];
				this.m_sPlayers[this.m_Order[this.m_UserIdx]].m_LimitCardOut[1] = buf[3];
			}
			this.m_sPlayers[this.m_Order[this.m_UserIdx]].EnableCards(true, fgTing);
			CGame.DebugLog("MJGAME_WAITCARDOUT:", size, buf[0], buf[1]);
		}
		else if ( subType == CMJClass.MJGAME_PLAYERCARDOUT ) {
			CGame.DebugLog("MJGAME_PLAYERCARDOUT:", size, buf[0], buf[1], buf[2].toString(16), buf[3], buf[4]);
			this.m_Turn = buf[0];
			this.PutCardOut(this.m_sPlayers[this.m_Order[this.m_Turn]], buf);
		}
		else if ( subType == CMJClass.MJGAME_CARDOUTREADY ) {
			CGame.DebugLog("MJGAME_CARDOUTREADY:", size, buf[0]);
			this.m_Turn = buf[0];
			this.m_cPointer.Show(this.GetPosDir(this.m_Turn));
			this.AddDelayCall(CMJGame.OUTCARD_SHOW_TIME, this.SendCardOutReady.bind(this));
		}
		else if ( subType == CMJClass.MJGAME_SHOWRULETIP ) {
			CGame.DebugLog("MJGAME_SHOWRULETIP:", size, buf[0]);
			if ( buf[0] == 10 ) {
				this.m_sPlayers[this.m_Order[this.m_UserIdx]].m_huoSkip = 1;
				this.ShowSkipHu(true);
			}
			else if ( buf[0] == 11 ) {
				this.m_sPlayers[this.m_Order[this.m_UserIdx]].m_huoSkip = 0;
				this.ShowSkipHu(false);
			}
			else {
				this.m_CRTips.ResetDM();
				this.m_CRTips.Show(buf[0], 3500);
			}
		}
		else if ( subType == CMJClass.MJGAME_ACTIONMENU ) {
			CGame.DebugLog("MJGAME_ACTIONMENU:", size, buf[0]);
			this.BuildActionMenu(buf);
		}
		else if ( subType == CMJClass.MJGAME_ACTIONSEL ) {
			CGame.DebugLog("MJGAME_ACTIONSEL:", size, buf[0]);
			this.DoActionSel(buf);
		}
		else if ( subType == CMJClass.MJGAME_PREPARERESULT ) {
			this.PrepareResult(size, buf);
		}
		else if ( subType == CMJClass.MJGAME_DORESULT ) {
			this.DoResult(size, buf);
		}
		else if ( subType == CMJClass.MJGAME_NEXTROUND ) {
			this.HideResultPanel();
		}
		else if ( subType == CMJClass.MJGAME_GAMEOVER ) {
			if( this.m_WorkBuf[0] == CEnumTypes.ENDGAME_NORMAL ) this.HideResultPanel();
			this.PreGameOver();
			//this.AddDelayCall(500, this.DoGameOver.bind(this));
		}
		else if ( subType == CMJClass.MJGAME_REQUEST_DISMISS ) {
			let who = buf.GetInt(ofs);
			CGame.DebugLog("MJGAME_REQUEST_DISMISS:", who);
			if( this.m_sPlayers[who].m_nPlayerNum == 0 ) {
				this.mGame.ShowDialog("解散房間", "詢問其他玩家中… ", []);
			}
			else {
				this.mGame.ShowDialog("解散房間", "有玩家("+this.m_sPlayers[who].GetName()+")發起解散，確定要答應嗎？", 
					["那好吧","我不想"], this.onAnsDismissDlg.bind(this));
			}
		}
		else if ( subType == CMJClass.MJGAME_FEEDBACK_DISMISS ) {
			let fg = buf.GetInt(ofs); ofs += 4;
			CGame.DebugLog("MJGAME_FEEDBACK_DISMISS:", fg);
			for( i = 0; i < CDefine.PLAYER_NUMS; i ++ ) {
				this.m_sPlayers[i].m_ansDismiss = buf[ofs+i];
				this.m_sPlayers[i].updateAnsDismiss(true);
			}
			if( fg == -1 ) {
				var that = this;
				this.mGame.updateDialog("解散房間", "玩家中有人不想解散，牌局將繼續", function(result){
					that.HidePlayersAnsDismiss();
				});
				// this.mGame.updateDialog("解散房間", "玩家中有人不想解散，牌局將繼續", ["確定"], function(result){
				// 	that.m_RemoteStep[0] = CEnumTypes.DISMISS_DONE;
				// 	that.SendFlag(CMJClass.MJGAME_END_DISMISS, this.m_RemoteStep, 1);
				// 	that.HidePlayersAnsDismiss();
				// });
			}
		}
		else if ( subType == CMJClass.MJGAME_SYNCCARDS ) {
			for( i = 0; i < CDefine.CARDS_PER_PLAYER; i ++ ) this.m_SyncCardBuf[i] = buf[i];
			// this.SyncCardsCheck();
		}
	}

	public ProcessMessage(p:CByteArray):number {
		var ret = 1;
		var i, subType:number;
		
		var type:number = p.readByte();
		CGame.DebugLog("ProcessGameMessage type:", type);
		if( type == CNetPeer.ID_MSG_CONNECTION_ACCEPTED ) {
			// CGame.DebugLog("ID_MSG_CONNECTION_ACCEPTED");
			// this.mGame.resetPacket();
			// this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_GAME_SESSION);
			// this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_ENTER_GAME);
			// this.mGame.m_CPkt.WriteInt(this.mGame.m_clTable.idxTable);
			// this.mGame.m_CPkt.WriteInt(this.mGame.m_pUserPlayer.DBID);
			// this.mGame.m_CPkt.WriteUTFBytes(this.mGame.m_pUserPlayer.openid, CLoginPlayer.OPENID_LEN);
			// this.mGame.m_CPkt.WriteUTFBytes(this.mGame.m_clTable.password, 10);
			// this.mGame.SendData(this.mGame.m_CPkt, 1);
		}
		else if( type == CEnumTypes.ID_MSG_RECONNECT_DATA ) {
			CGame.DebugLog("ID_MSG_RECONNECT_DATA");
			this.mGame.PauseProcessMsg();
			this.RecvReConnectData(p);
			this.mGame.ResumeProcessMsg();
		}
		else if( type == CEnumTypes.ID_MSG_ENTER_GAME ) {
			CGame.DebugLog("ID_MSG_GAME_LOGIN");
			for( i = 0; i < CDefine.PLAYER_NUMS; i ++ ) {
				p.readBytes(this.m_GTable.player[i].getData(), 0, CLoginPlayer.DATA_SIZE);
			}
			p.readBytes(this.m_GTable.option, 0, 20);
			for( i = 0; i < CDefine.PLAYER_NUMS; i ++ ) {
				CGame.DebugLog(this.m_GTable.player[i].DBID, this.m_GTable.player[i].openid, this.m_GTable.player[i].socialName);
			}
			this.onLoginGameServer();
		}
		else if( type == CEnumTypes.ID_MSG_GAME_START ) {
			let v = p.readByte();
			for( i = 0; i < CDefine.PLAYER_NUMS; i ++ ) {
				this.m_GTable.player[i].index = p.readInt();
			}
			for( i = 0; i < CDefine.PLAYER_NUMS; i ++ ) {
				if ( !(v & (1 << i)) ) {
					if( this.mGame.m_pUserPlayer.DBID == this.m_GTable.player[i].DBID ) {
						CGame.DebugLog("Err:08 Connection attempt failed !!!");
					}
					this.m_GTable.player[i].DBID = -1;
					this.m_GTable.PlayerLeftGame(i, 255);
				}
			}
			CGame.DebugLog("ID_MSG_GAME_START:");
			for( i = 0; i < CDefine.PLAYER_NUMS; i ++ ) {
				CGame.DebugLog("player:", i, this.m_GTable.IsRobot(i));
			}
			this.SendFlag(CMJClass.MJGAME_DECIDESEAT, this.m_RemoteStep, 0);
		}
		else if( type == CEnumTypes.ID_MSG_GAME_MESSAGE ) {
			subType = p.readByte();
			if ( subType != CMJClass.MJGAME_COUNTDOWN ) CGame.DebugLog("subType:", subType);
			if( subType == CMJClass.MJGAME_LOGINSTATUS ) {
				let st:CByteArray = new CByteArray(4);
				p.readBytes(st, 0, 4);
				CGame.DebugLog("MJGAME_LOGINSTATUS:", st[0], st[1], st[2], st[3]);
			}
			else {
				let size = p.readShort();
				this.m_WorkBuf.size = 0;
				if( size > 0 ) {
					p.readBytes(this.m_WorkBuf, 0, size);
					this.m_WorkBuf.size = size;
				}
				this.onRecvGameStepMsg(subType);
			}
		}
		else if( type == CEnumTypes.ID_MSG_ERROR ) {
			var errMsg:string = p.readUTFBytes(CDefine.MAX_ERRMSG_LEN);
			CGame.DebugLog("Error:" + errMsg);
			ret = CGameBase.ERR_DISCONNECT;
			this.mGame.ShowDialog("錯誤!!", errMsg, ["確定"], function (result) {
				CGame.DebugLog(result);
				CGame.Instance.Back2Web();
				// CMJLogin.Instance.EnableButtons(true);
			});
       	}
	   	return ret;
	}

	public Frame(game: CGameBase): void {
		if( this.mainView == null ) return;

		this.ProcessUserOperation();
		// if( CGame.Instance.m_tmBlur != 0 ) {
		// 	let d = new Date();
		// 	let dm = (d.getTime() - CGame.Instance.m_tmBlur) / 1000;
		// 	if( dm >= CGame.secs_RefreshPage ) location.reload();
		// }
		if( this.m_tmBack2Lobby != 0 ) {
			let d = new Date();
			let dm = (d.getTime() - this.m_tmBack2Lobby) / 1000;
			if( dm >= 10 ) this.HideFinalResultPanel();
		}
	}
}